import { createSlice } from "@reduxjs/toolkit";
import IPlayer from "../models/player.model";
import { ItemStack } from "../models/itemStack.model";
import { MapVisibility } from "../models/mapVisibility";

interface IGameSliceState {
  backpackClasses: string[];
  magazineClasses: string[];
  weaponClasses: string[];
  selectedClasses: {
    weapons: ItemStack[];
    magazines: ItemStack[];
    backpacks: ItemStack[];
  };
  playerList: IPlayer[];
  mapVisibility: MapVisibility;
}

const initialState: IGameSliceState = {
  backpackClasses: [
    "USBasicBag",
    "Tripod_Bag",
    "M2StaticMG_US_Bag_EP1",
    "M2HD_mini_TriPod_US_Bag_EP1",
    "DSHKM_TK_GUE_Bag_EP1",
    "DSHKM_TK_INS_Bag_EP1",
    "DSHkM_Mini_TriPod_TK_GUE_Bag_EP1",
    "DSHkM_Mini_TriPod_TK_INS_Bag_EP1",
    "KORD_high_TK_Bag_EP1",
    "KORD_high_UN_Bag_EP1",
    "KORD_TK_Bag_EP1",
    "KORD_UN_Bag_EP1",
    "MK19_TriPod_US_Bag_EP1",
    "AGS_TK_Bag_EP1",
    "AGS_TK_GUE_Bag_EP1",
    "AGS_TK_INS_Bag_EP1",
    "AGS_UN_Bag_EP1",
    "M252_US_Bag_EP1",
    "2b14_82mm_TK_Bag_EP1",
    "2b14_82mm_TK_GUE_Bag_EP1",
    "2b14_82mm_TK_INS_Bag_EP1",
    "Metis_TK_Bag_EP1",
    "TOW_TriPod_US_Bag_EP1",
    "SPG9_TK_GUE_Bag_EP1",
    "SPG9_TK_INS_Bag_EP1",
    "US_UAV_Pack_EP1",
    "US_Assault_Pack_EP1",
    "US_Assault_Pack_Ammo_EP1",
    "US_Assault_Pack_AmmoSAW_EP1",
    "US_Assault_Pack_AT_EP1",
    "US_Assault_Pack_Explosives_EP1",
    "US_Patrol_Pack_EP1",
    "US_Patrol_Pack_Ammo_EP1",
    "US_Patrol_Pack_Specops_EP1",
    "US_Backpack_EP1",
    "US_Backpack_AmmoMG_EP1",
    "US_Backpack_AT_EP1",
    "US_Backpack_Specops_EP1",
    "DE_Backpack_Specops_EP1",
    "CZ_Backpack_EP1",
    "CZ_Backpack_Ammo_EP1",
    "CZ_Backpack_Specops_EP1",
    "CZ_Backpack_AmmoMG_EP1",
    "CZ_VestPouch_EP1",
    "CZ_VestPouch_Sa58_EP1",
    "CZ_VestPouch_M4_EP1",
    "TK_RPG_Backpack_EP1",
    "TK_ALICE_Pack_EP1",
    "TK_ALICE_Pack_Explosives_EP1",
    "TK_ALICE_Pack_AmmoMG_EP1",
    "TKA_ALICE_Pack_Ammo_EP1",
    "TKG_ALICE_Pack_AmmoAK47_EP1",
    "TKG_ALICE_Pack_AmmoAK74_EP1",
    "TK_Assault_Pack_EP1",
    "TK_Assault_Pack_RPK_EP1",
    "TKA_Assault_Pack_Ammo_EP1",
    "BAF_L2A1_ACOG_tripod_bag",
    "BAF_L2A1_ACOG_minitripod_bag",
    "BAF_GPMG_Minitripod_D_bag",
    "BAF_GMG_ACOG_minitripod_bag",
    "RBS70_Bag_ACR",
    "DZ_Patrol_Pack_EP1",
    "DZ_Assault_Pack_EP1",
    "DZ_Czech_Vest_Pouch",
    "DZ_ALICE_Pack_EP1",
    "DZ_TK_Assault_Pack_EP1",
    "DZ_British_ACU",
    "DZ_CivilBackpack_EP1",
    "DZ_Backpack_EP1",
    "DZ_LargeGunBag_EP1",
    "DZ_GunBag_EP1",
    "DZ_CompactPack_EP1",
    "DZ_TerminalPack_EP1",
    "Patrol_Pack_DZE1",
    "Patrol_Pack_DZE2",
    "GymBag_Camo_DZE1",
    "GymBag_Camo_DZE2",
    "GymBag_Green_DZE1",
    "GymBag_Green_DZE2",
    "Czech_Vest_Pouch_DZE1",
    "Czech_Vest_Pouch_DZE2",
    "Assault_Pack_DZE1",
    "Assault_Pack_DZE2",
    "TerminalPack_DZE1",
    "TerminalPack_DZE2",
    "TinyPack_DZE1",
    "TinyPack_DZE2",
    "ALICE_Pack_DZE1",
    "ALICE_Pack_DZE2",
    "TK_Assault_Pack_DZE1",
    "TK_Assault_Pack_DZE2",
    "School_Bag_DZE1",
    "School_Bag_DZE2",
    "CompactPack_DZE1",
    "CompactPack_DZE2",
    "British_ACU_DZE1",
    "British_ACU_DZE2",
    "GunBag_DZE1",
    "GunBag_DZE2",
    "PartyPack_DZE1",
    "PartyPack_DZE2",
    "NightPack_DZE1",
    "NightPack_DZE2",
    "SurvivorPack_DZE1",
    "SurvivorPack_DZE2",
    "AirwavesPack_DZE1",
    "AirwavesPack_DZE2",
    "CzechBackpack_DZE1",
    "CzechBackpack_DZE2",
    "CzechBackpack_Camping_DZE1",
    "CzechBackpack_Camping_DZE2",
    "CzechBackpack_OD_DZE1",
    "CzechBackpack_OD_DZE2",
    "CzechBackpack_DES_DZE1",
    "CzechBackpack_DES_DZE2",
    "CzechBackpack_3DES_DZE1",
    "CzechBackpack_3DES_DZE2",
    "CzechBackpack_WDL_DZE1",
    "CzechBackpack_WDL_DZE2",
    "CzechBackpack_MAR_DZE1",
    "CzechBackpack_MAR_DZE2",
    "CzechBackpack_DMAR_DZE1",
    "CzechBackpack_DMAR_DZE2",
    "CzechBackpack_UCP_DZE1",
    "CzechBackpack_UCP_DZE2",
    "CzechBackpack_6DES_DZE1",
    "CzechBackpack_6DES_DZE2",
    "CzechBackpack_TAK_DZE1",
    "CzechBackpack_TAK_DZE2",
    "CzechBackpack_NVG_DZE1",
    "CzechBackpack_NVG_DZE2",
    "CzechBackpack_BLK_DZE1",
    "CzechBackpack_BLK_DZE2",
    "CzechBackpack_DPM_DZE1",
    "CzechBackpack_DPM_DZE2",
    "CzechBackpack_FIN_DZE1",
    "CzechBackpack_FIN_DZE2",
    "CzechBackpack_MTC_DZE1",
    "CzechBackpack_MTC_DZE2",
    "CzechBackpack_NOR_DZE1",
    "CzechBackpack_NOR_DZE2",
    "CzechBackpack_WIN_DZE1",
    "CzechBackpack_WIN_DZE2",
    "CzechBackpack_ATC_DZE1",
    "CzechBackpack_ATC_DZE2",
    "CzechBackpack_MTL_DZE1",
    "CzechBackpack_MTL_DZE2",
    "CzechBackpack_FTN_DZE1",
    "CzechBackpack_FTN_DZE2",
    "WandererBackpack_DZE1",
    "WandererBackpack_DZE2",
    "LegendBackpack_DZE1",
    "LegendBackpack_DZE2",
    "CoyoteBackpack_DZE1",
    "CoyoteBackpack_DZE2",
    "CoyoteBackpackDes_DZE1",
    "CoyoteBackpackDes_DZE2",
    "CoyoteBackpackWdl_DZE1",
    "CoyoteBackpackWdl_DZE2",
    "CoyoteBackpack_Camping_DZE1",
    "CoyoteBackpack_Camping_DZE2",
    "LargeGunBag_DZE1",
    "LargeGunBag_DZE2",
  ],
  magazineClasses: [
    "3Rnd_GyroGrenade",
    "14Rnd_FFAR",
    "12Rnd_FFAR",
    "3rnd_Anzio_20x102mm",
    "350Rnd_BB_Magazine",
    "8Rnd_9x18_Makarov",
    "8Rnd_9x18_MakarovSD",
    "15Rnd_9x19_M9",
    "15Rnd_9x19_M9SD",
    "30Rnd_9x19_MP5SD",
    "30Rnd_9x19_MP5",
    "7Rnd_45ACP_1911",
    "30Rnd_545x39_AK",
    "30Rnd_545x39_AKSD",
    "75Rnd_545x39_RPK",
    "30Rnd_762x39_AK47",
    "20Rnd_556x45_Stanag",
    "30Rnd_556x45_Stanag",
    "30Rnd_556x45_StanagSD",
    "30Rnd_556x45_G36",
    "30Rnd_556x45_G36SD",
    "200Rnd_556x45_M249",
    "100Rnd_556x45_BetaCMag",
    "5Rnd_762x51_M24",
    "100Rnd_762x51_M240",
    "10Rnd_762x54_SVD",
    "100Rnd_762x54_PK",
    "60Rnd_762x54_DT",
    "64Rnd_9x19_Bizon",
    "64Rnd_9x19_SD_Bizon",
    "10Rnd_9x39_SP5_VSS",
    "20Rnd_9x39_SP5_VSS",
    "8Rnd_B_Saiga12_74Slug",
    "8Rnd_B_Beneli_74Slug",
    "5Rnd_127x108_KSVK",
    "10Rnd_127x99_m107",
    "1Rnd_HE_M203",
    "FlareWhite_M203",
    "FlareGreen_M203",
    "FlareRed_M203",
    "FlareYellow_M203",
    "1Rnd_Smoke_M203",
    "1Rnd_SmokeRed_M203",
    "1Rnd_SmokeGreen_M203",
    "1Rnd_SmokeYellow_M203",
    "1Rnd_HE_GP25",
    "FlareWhite_GP25",
    "FlareGreen_GP25",
    "FlareRed_GP25",
    "FlareYellow_GP25",
    "1Rnd_SMOKE_GP25",
    "1Rnd_SmokeRed_GP25",
    "1Rnd_SmokeGreen_GP25",
    "1Rnd_SmokeYellow_GP25",
    "M136",
    "Javelin",
    "AT13",
    "PG7V",
    "PG7VL",
    "PG7VR",
    "OG7",
    "PG9_AT",
    "OG9_HE",
    "Stinger",
    "8Rnd_Stinger",
    "2Rnd_Stinger",
    "Strela",
    "RPG18",
    "SMAW_HEDP",
    "SMAW_HEAA",
    "Igla",
    "2Rnd_Igla",
    "SmokeLauncherMag",
    "FlareLauncherMag",
    "4000Rnd_762x51_M134",
    "2000Rnd_762x51_M134",
    "1200Rnd_762x51_M240",
    "1500Rnd_762x54_PKT",
    "2000Rnd_762x54_PKT",
    "200Rnd_762x54_PKT",
    "250Rnd_762x54_PKT_T90",
    "500Rnd_TwinVickers",
    "100Rnd_127x99_M2",
    "250Rnd_127x99_M3P",
    "50Rnd_127x107_DSHKM",
    "150Rnd_127x107_DSHKM",
    "150Rnd_127x108_KORD",
    "50Rnd_127x108_KORD",
    "1470Rnd_127x108_YakB",
    "500Rnd_145x115_KPVT",
    "750Rnd_M197_AH1",
    "2100Rnd_20mm_M168",
    "2000Rnd_23mm_AZP85",
    "40Rnd_23mm_AZP85",
    "1000Rnd_23mm_2A14_HE",
    "1000Rnd_23mm_2A14_AP",
    "520Rnd_23mm_GSh23L",
    "300Rnd_25mm_GAU12",
    "210Rnd_25mm_M242_HEI",
    "210Rnd_25mm_M242_APDS",
    "29Rnd_30mm_AGS30",
    "400Rnd_30mm_AGS17",
    "230Rnd_30mmHE_2A42",
    "250Rnd_30mmHE_2A42",
    "150Rnd_30mmHE_2A42",
    "230Rnd_30mmAP_2A42",
    "250Rnd_30mmAP_2A42",
    "150Rnd_30mmAP_2A42",
    "250Rnd_30mmHE_2A72",
    "250Rnd_30mmAP_2A72",
    "1904Rnd_30mmAA_2A38M",
    "1350Rnd_30mmAP_A10",
    "180Rnd_30mm_GSh301",
    "750Rnd_30mm_GSh301",
    "48Rnd_40mm_MK19",
    "6Rnd_Grenade_Camel",
    "30Rnd_105mmHE_M119",
    "20Rnd_120mmHE_M1A2",
    "20Rnd_120mmSABOT_M1A2",
    "30Rnd_122mmHE_D30",
    "22Rnd_125mmHE_T72",
    "22Rnd_100mm_HE_2A70",
    "23Rnd_125mmSABOT_T72",
    "33Rnd_85mmHE",
    "10Rnd_85mmAP",
    "8Rnd_AT5_BMP2",
    "5Rnd_AT5_BRDM2",
    "4Rnd_AT9_Mi24P",
    "4Rnd_AT6_Mi24V",
    "4Rnd_AT2_Mi24D",
    "8Rnd_AT10_BMP3",
    "5Rnd_AT11_T90",
    "6Rnd_AT13",
    "6Rnd_TOW_HMMWV",
    "2Rnd_TOW",
    "6Rnd_TOW2",
    "2Rnd_TOW2",
    "8Rnd_Hellfire",
    "12Rnd_Vikhr_KA50",
    "4Rnd_Sidewinder_AV8B",
    "2Rnd_Sidewinder_F35",
    "2Rnd_Sidewinder_AH1Z",
    "28Rnd_FFAR",
    "38Rnd_FFAR",
    "40Rnd_80mm",
    "80Rnd_80mm",
    "40Rnd_GRAD",
    "12Rnd_MLRS",
    "40Rnd_S8T",
    "80Rnd_S8T",
    "64Rnd_57mm",
    "128Rnd_57mm",
    "192Rnd_57mm",
    "6Rnd_GBU12_AV8B",
    "2Rnd_GBU12",
    "4Rnd_GBU12",
    "2Rnd_FAB_250",
    "4Rnd_FAB_250",
    "6Rnd_Mk82",
    "3Rnd_Mk82",
    "4Rnd_R73",
    "2Rnd_R73",
    "4Rnd_Ch29",
    "6Rnd_Ch29",
    "2Rnd_Maverick_A10",
    "8Rnd_9M311",
    "Mine",
    "MineE",
    "PipeBomb",
    "HandGrenade",
    "HandGrenade_Stone",
    "HandGrenade_West",
    "HandGrenade_East",
    "SmokeShell",
    "SmokeShellRed",
    "SmokeShellGreen",
    "SmokeShellYellow",
    "SmokeShellPurple",
    "SmokeShellBlue",
    "SmokeShellOrange",
    "Laserbatteries",
    "20Rnd_762x51_DMR",
    "5x_22_LR_17_HMR",
    "1200Rnd_30x113mm_M789_HEDP",
    "8Rnd_Sidewinder_AH64",
    "ARTY_30Rnd_105mmHE_M119",
    "ARTY_30Rnd_105mmWP_M119",
    "ARTY_30Rnd_105mmSADARM_M119",
    "ARTY_30Rnd_105mmLASER_M119",
    "ARTY_30Rnd_105mmSMOKE_M119",
    "ARTY_30Rnd_105mmILLUM_M119",
    "ARTY_8Rnd_81mmHE_M252",
    "ARTY_8Rnd_81mmWP_M252",
    "ARTY_8Rnd_81mmILLUM_M252",
    "ARTY_12Rnd_227mmHE_M270",
    "ARTY_30Rnd_122mmHE_D30",
    "ARTY_30Rnd_122mmWP_D30",
    "ARTY_30Rnd_122mmSADARM_D30",
    "ARTY_30Rnd_122mmLASER_D30",
    "ARTY_30Rnd_122mmSMOKE_D30",
    "ARTY_30Rnd_122mmILLUM_D30",
    "ARTY_8Rnd_82mmHE_2B14",
    "ARTY_8Rnd_82mmWP_2B14",
    "ARTY_8Rnd_82mmILLUM_2B14",
    "ARTY_40Rnd_120mmHE_BM21",
    "Warfare30Rnd82mmMortar",
    "100Rnd_127x99_L2A1",
    "5Rnd_127x99_as50",
    "5Rnd_86x70_L115A1",
    "NLAW",
    "200Rnd_556x45_L110A1",
    "200Rnd_762x54_GPMG",
    "32Rnd_40mm_GMG",
    "12Rnd_CRV7",
    "38Rnd_CRV7",
    "6Rnd_CRV7_HEPD",
    "6Rnd_CRV7_FAT",
    "1200Rnd_20mm_M621",
    "2000Rnd_762x51_L94A1",
    "200Rnd_762x51_M240",
    "BAF_ied_v1",
    "BAF_ied_v2",
    "BAF_ied_v3",
    "BAF_ied_v4",
    "BAF_L109A1_HE",
    "21Rnd_100mmHEAT_D10",
    "6RND_105mm_APDS",
    "12RND_105mm_HESH",
    "4Rnd_Hellfire",
    "10Rnd_B_765x17_Ball",
    "20Rnd_B_765x17_Ball",
    "4Rnd_Stinger",
    "30Rnd_9x19_UZI_SD",
    "30Rnd_9x19_UZI",
    "6Rnd_45ACP",
    "17Rnd_9x19_glock17",
    "MAAWS_HEDP",
    "MAAWS_HEAT",
    "20Rnd_762x51_B_SCAR",
    "20Rnd_762x51_SB_SCAR",
    "30Rnd_762x39_SA58",
    "100Rnd_556x45_M249",
    "IR_Strobe_Target",
    "IR_Strobe_Marker",
    "IRStrobe",
    "60Rnd_CMFlareMagazine",
    "120Rnd_CMFlareMagazine",
    "240Rnd_CMFlareMagazine",
    "60Rnd_CMFlare_Chaff_Magazine",
    "120Rnd_CMFlare_Chaff_Magazine",
    "240Rnd_CMFlare_Chaff_Magazine",
    "6Rnd_HE_M203",
    "6Rnd_FlareWhite_M203",
    "6Rnd_FlareGreen_M203",
    "6Rnd_FlareRed_M203",
    "6Rnd_FlareYellow_M203",
    "6Rnd_Smoke_M203",
    "6Rnd_SmokeRed_M203",
    "6Rnd_SmokeGreen_M203",
    "6Rnd_SmokeYellow_M203",
    "24Rnd_120mmHE_M120",
    "24Rnd_120mmHE_M120_02",
    "8Rnd_81mmHE_M252",
    "8Rnd_81mmWP_M252",
    "8Rnd_81mmILLUM_M252",
    "8Rnd_82mmHE_2B14",
    "8Rnd_82mmWP_2B14",
    "8Rnd_82mmILLUM_2B14",
    "30Rnd_122mmWP_D30",
    "30Rnd_122mmSADARM_D30",
    "30Rnd_122mmLASER_D30",
    "30Rnd_122mmSMOKE_D30",
    "30Rnd_122mmILLUM_D30",
    "30Rnd_105mmWP_M119",
    "30Rnd_105mmSADARM_M119",
    "30Rnd_105mmLASER_M119",
    "30Rnd_105mmSMOKE_M119",
    "30Rnd_105mmILLUM_M119",
    "20Rnd_762x51_FNFAL",
    "10x_303",
    "Dragon_EP1",
    "PMC_ied_v1",
    "PMC_ied_v2",
    "PMC_ied_v3",
    "PMC_ied_v4",
    "8Rnd_B_Saiga12_Pellets",
    "8Rnd_B_Beneli_Pellets",
    "20Rnd_B_AA12_Pellets",
    "20Rnd_B_AA12_74Slug",
    "20Rnd_B_AA12_HE",
    "29Rnd_30mm_AGS30_heli",
    "100Rnd_556x45_BetaCMag_airLock",
    "14Rnd_57mm",
    "6Rnd_HE_M203_heli",
    "150Rnd_23mm_GSh23L",
    "1Rnd_Bolide",
    "210Rnd_20mm_ZPL_20",
    "8Rnd_AT9_Mi24V",
    "4Rnd_Maverick_L159",
    "140Rnd_30mm_ATKMK44_HE_ACR",
    "60Rnd_30mm_ATKMK44_AP_ACR",
    "460Rnd_762x51_M240_ACR",
    "2Rnd_Spike_ACR",
    "10Rnd_9x19_Compact",
    "18Rnd_9x19_Phantom",
    "18Rnd_9x19_PhantomSD",
    "10Rnd_762x51_CZ750",
    "20Rnd_9x19_EVOSD",
    "20Rnd_9x19_EVO",
    "PG15V",
    "40rnd_PG15V",
    "AT3",
    "4rnd_AT3",
    "22Rnd_125mmSABOT_IMI",
    "15Rnd_125mmHE_T72CZ",
    "40Rnd_GRAD_ACR",
    "pook_1300Rnd_762x51_M60",
    "pook_250Rnd_762x51",
    "pook_12Rnd_Grenade_Camel",
    "SMAW_HEDP_Big",
    "SMAW_HEAA_Big",
    "NLAW_Big",
    "1Rnd_AT3",
    "2Rnd_Mk82",
    "4Rnd_Mk82",
    "2Rnd_GBU12_AV8B",
    "4Rnd_GBU12_AV8B",
    "400Rnd_20mm_M621",
    "5Rnd_127x99_as50_CP",
    "220Rnd_25mm_GAU22",
    "8Rnd_Ch29",
    "Hatchet_Swing",
    "Crowbar_Swing",
    "Machete_Swing",
    "Fishing_Swing",
    "Bat_Swing",
    "BatBarbed_Swing",
    "BatNails_Swing",
    "10Rnd_22lfB_RUGERMK2",
    "7Rnd_9x17_PPK",
    "20Rnd_9x18_APS",
    "20Rnd_9x18_APSSD",
    "17Rnd_9x19_glock17SD",
    "13Rnd_9x19_BHP",
    "15Rnd_9x19_P226",
    "8Rnd_9x19_P38",
    "8Rnd_9x19_MK22",
    "8Rnd_9x19_MK22SD",
    "20Rnd_9x19_M93R",
    "33Rnd_9x19_G18",
    "32Rnd_9x19_TEC9",
    "30Rnd_9x19_TMP",
    "30Rnd_9x19_TMPSD",
    "32Rnd_9x19_STEN",
    "32Rnd_9x19_MAT49",
    "70Rnd_9x19_M31",
    "15Rnd_10x22_p99",
    "15Rnd_10x22_p99_sd",
    "15Rnd_45ACP_USP",
    "15Rnd_45ACP_USPSD",
    "7Rnd_45ACP_1911SD",
    "33Rnd_45ACP_KRISS",
    "33Rnd_45ACP_KRISSSD",
    "25Rnd_45ACP_UMP",
    "25Rnd_45ACP_UMPSD",
    "6Rnd_44Magnum",
    "6Rnd_357Magnum",
    "7Rnd_50AE_Deagle",
    "60Rnd_545x39_AK_Taped",
    "60Rnd_545x39_AKSD_Taped",
    "100Rnd_556x45_BetaCMagSD",
    "60Rnd_556x45_Stanag_Taped",
    "60Rnd_556x45_StanagSD_Taped",
    "30Rnd_556x45_Aug",
    "30Rnd_6x35_KAC",
    "8Rnd_762x25_TT33",
    "60Rnd_762x39_AK47_Taped",
    "75Rnd_762x39_RPK",
    "30Rnd_762x39_RK95",
    "30Rnd_762x39_RK95SD",
    "30Rnd_762x39_Groza1",
    "30Rnd_762x39_Groza1SD",
    "20Rnd_762x51_G3",
    "20Rnd_762x51_DMRSD",
    "20Rnd_762x51_RSASS",
    "20Rnd_762x51_RSASS_SD",
    "20Rnd_762x51_HK417",
    "20Rnd_762x51_HK417SD",
    "6Rnd_762x51_WA2000",
    "50Rnd_762x54_UK59",
    "5Rnd_762x54_Mosin",
    "40Rnd_46x30_mp7",
    "40Rnd_46x30_sd_mp7",
    "50Rnd_57x28_P90",
    "50Rnd_57x28_P90SD",
    "ACR_30Rnd_680x43",
    "ACR_30Rnd_680x43_SD",
    "7Rnd_86x70_MSR",
    "7Rnd_86x70_MSR_SD",
    "10Rnd_86x70_MRAD",
    "5Rnd_762x67_XM2010",
    "5Rnd_762x67_XM2010_SD",
    "20Rnd_9x39_Groza9",
    "20Rnd_9x39_Groza9SD",
    "5Rnd_408_CheyTac",
    "5Rnd_408_CheyTac_SD",
    "5Rnd_17HMR",
    "10Rnd_303British",
    "15Rnd_W1866_Slug",
    "8Rnd_12Gauge_Slug",
    "2Rnd_12Gauge_Slug",
    "8Rnd_12Gauge_Buck",
    "2Rnd_12Gauge_Buck",
    "20Rnd_B_Usas12_74Slug",
    "20Rnd_B_Usas12_Pellets",
    "1Rnd_Arrow_Wood",
    "12Rnd_Quiver_Wood",
    "1Rnd_Bolt_Tranquilizer",
    "1Rnd_Bolt_Explosive",
    "Attachment_SCOPED",
    "Attachment_BELT",
    "Attachment_FL",
    "Attachment_FL_Pist",
    "Attachment_MFL",
    "Attachment_MFL_Pist",
    "Attachment_CCO",
    "Attachment_Holo",
    "Attachment_ACOG",
    "Attachment_Kobra",
    "Attachment_PSO1",
    "Attachment_M203",
    "Attachment_GP25",
    "Attachment_Sup9",
    "Attachment_Sup10",
    "Attachment_Sup45",
    "Attachment_Sup57",
    "Attachment_Sup68",
    "Attachment_Sup556",
    "Attachment_Sup545",
    "Attachment_Sup762",
    "Attachment_Sup939",
    "Attachment_SupMakarov",
    "Attachment_SupBizon",
    "Attachment_Ghillie",
    "Attachment_Ghillie_Desert",
    "Attachment_Ghillie_Snow",
    "Attachment_Ghillie_Urban",
    "Attachment_SA58RIS",
    "Attachment_ANPVS4",
    "Attachment_Laser",
    "Attachment_NSPU",
    "Attachment_NV",
    "Attachment_Tws",
    "FoodMRE",
    "FoodPistachio",
    "FoodNutmix",
    "FoodCanBeef",
    "FoodCanPotatoes",
    "FoodCanGriff",
    "FoodCanBadguy",
    "FoodCanBoneboy",
    "FoodCanCorn",
    "FoodCanCurgon",
    "FoodCanDemon",
    "FoodCanFraggleos",
    "FoodCanHerpy",
    "FoodCanDerpy",
    "FoodCanOrlok",
    "FoodCanPowell",
    "FoodCanTylers",
    "FoodCanUnlabeled",
    "FoodCanRusUnlabeled",
    "FoodCanRusStew",
    "FoodCanRusPork",
    "FoodCanRusPeas",
    "FoodCanRusMilk",
    "FoodCanRusCorn",
    "FoodChipsSulahoops",
    "FoodChipsMysticales",
    "FoodChipsChocolate",
    "FoodCandyChubby",
    "FoodCandyAnders",
    "FoodCandyLegacys",
    "FoodCakeCremeCakeClean",
    "FoodCandyMintception",
    "FoodCanBakedBeans",
    "FoodCanSardines",
    "FoodCanFrankBeans",
    "FoodCanPasta",
    "FoodBioMeat",
    "FoodGoatRaw",
    "FoodGoatCooked",
    "FoodMuttonRaw",
    "FoodMuttonCooked",
    "FoodChickenRaw",
    "FoodChickenCooked",
    "FoodBaconRaw",
    "FoodBaconCooked",
    "FoodRabbitRaw",
    "FoodRabbitCooked",
    "FoodBeefRaw",
    "FoodBeefCooked",
    "FoodDogRaw",
    "FoodDogCooked",
    "FishRawTrout",
    "FishCookedTrout",
    "FishRawSeaBass",
    "FishCookedSeaBass",
    "FishRawTuna",
    "FishCookedTuna",
    "equip_garlic_bulb",
    "FoodPumpkin",
    "ItemPumpkinSeed",
    "FoodSunFlowerSeed",
    "FoodPotatoRaw",
    "FoodPotatoBaked",
    "FoodCarrot",
    "ItemSodaCoke",
    "ItemSodaPepsi",
    "ItemSodaMdew",
    "ItemSodaMtngreen",
    "ItemSodaR4z0r",
    "ItemSodaClays",
    "ItemSodaSmasht",
    "ItemSodaDrwaste",
    "ItemSodaFranka",
    "ItemSodaLemonade",
    "ItemSodaLirik",
    "ItemSodaLvg",
    "ItemSodaMzly",
    "ItemSodaPeppsy",
    "ItemSodaRabbit",
    "ItemSodaSacrite",
    "ItemSodaRocketFuel",
    "ItemSodaGrapeDrink",
    "ItemSherbet",
    "ItemSodaRbull",
    "ItemSodaOrangeSherbet",
    "ItemWaterBottle",
    "ItemWaterBottleInfected",
    "ItemWaterBottleSafe",
    "ItemWaterBottleBoiled",
    "ItemWaterBottleHerbal",
    "ItemWaterBottleUnfilled",
    "ItemWaterBottleDmg",
    "ItemWaterbottle1oz",
    "ItemWaterbottle2oz",
    "ItemWaterbottle3oz",
    "ItemWaterbottle4oz",
    "ItemWaterbottle5oz",
    "ItemWaterbottle6oz",
    "ItemWaterbottle7oz",
    "ItemWaterbottle8oz",
    "ItemWaterbottle9oz",
    "ItemWaterbottle1ozBoiled",
    "ItemWaterbottle2ozBoiled",
    "ItemWaterbottle3ozBoiled",
    "ItemWaterbottle4ozBoiled",
    "ItemWaterbottle5ozBoiled",
    "ItemWaterbottle6ozBoiled",
    "ItemWaterbottle7ozBoiled",
    "ItemWaterbottle8ozBoiled",
    "ItemWaterbottle9ozBoiled",
    "ItemPlasticWaterbottleUnfilled",
    "ItemPlasticWaterbottleDmg",
    "ItemPlasticWaterBottle",
    "ItemPlasticWaterBottleInfected",
    "ItemPlasticWaterBottleSafe",
    "ItemPlasticWaterBottleBoiled",
    "ItemPlasticWaterBottleHerbal",
    "ItemPlasticWaterbottle1oz",
    "ItemPlasticWaterbottle2oz",
    "ItemPlasticWaterbottle3oz",
    "ItemPlasticWaterbottle4oz",
    "ItemPlasticWaterbottle5oz",
    "ItemPlasticWaterbottle6oz",
    "ItemPlasticWaterbottle7oz",
    "ItemPlasticWaterbottle8oz",
    "ItemPlasticWaterbottle9oz",
    "ItemPlasticWaterbottle1ozBoiled",
    "ItemPlasticWaterbottle2ozBoiled",
    "ItemPlasticWaterbottle3ozBoiled",
    "ItemPlasticWaterbottle4ozBoiled",
    "ItemPlasticWaterbottle5ozBoiled",
    "ItemPlasticWaterbottle6ozBoiled",
    "ItemPlasticWaterbottle7ozBoiled",
    "ItemPlasticWaterbottle8ozBoiled",
    "ItemPlasticWaterbottle9ozBoiled",
    "ItemSodaEmpty",
    "TrashTinCan",
    "ItemSodaCokeEmpty",
    "ItemSodaPepsiEmpty",
    "ItemSodaMdewEmpty",
    "ItemSodaMtngreenEmpty",
    "ItemSodaR4z0rEmpty",
    "ItemSodaClaysEmpty",
    "ItemSodaSmashtEmpty",
    "ItemSodaDrwasteEmpty",
    "ItemSodaFrankaEmpty",
    "ItemSodaLemonadeEmpty",
    "ItemSodaLirikEmpty",
    "ItemSodaLvgEmpty",
    "ItemSodaMzlyEmpty",
    "ItemSodaPeppsyEmpty",
    "ItemSodaRabbitEmpty",
    "ItemSodaSacriteEmpty",
    "ItemSodaRocketFuelEmpty",
    "ItemSodaGrapeDrinkEmpty",
    "ItemSodaSherbetEmpty",
    "FoodCanBeefEmpty",
    "FoodCanPotatoesEmpty",
    "FoodCanGriffEmpty",
    "FoodCanBadguyEmpty",
    "FoodCanBoneboyEmpty",
    "FoodCanCornEmpty",
    "FoodCanCurgonEmpty",
    "FoodCanDemonEmpty",
    "FoodCanFraggleosEmpty",
    "FoodCanHerpyEmpty",
    "FoodCanDerpyEmpty",
    "FoodCanOrlokEmpty",
    "FoodCanPowellEmpty",
    "FoodCanTylersEmpty",
    "FoodCanUnlabeledEmpty",
    "FoodCanRusUnlabeledEmpty",
    "FoodCanRusStewEmpty",
    "FoodCanRusPorkEmpty",
    "FoodCanRusPeasEmpty",
    "FoodCanRusMilkEmpty",
    "FoodCanRusCornEmpty",
    "TrashJackDaniels",
    "ItemTrashRazor",
    "ItemTrashToiletpaper",
    "FoodChipsSulahoopsEmpty",
    "FoodChipsMysticalesEmpty",
    "FoodChipsChocolateEmpty",
    "Skin_Survivor2_DZ",
    "Skin_Camo1_DZ",
    "Skin_Rocket_DZ",
    "Skin_Soldier1_DZ",
    "Skin_Sniper1_DZ",
    "Skin_RU_Policeman_DZ",
    "Skin_RU_Policeman2_DZ",
    "Skin_Pilot_EP1_DZ",
    "Skin_Haris_Press_EP1_DZ",
    "Skin_Ins_Soldier_GL_DZ",
    "Skin_GUE_Commander_DZ",
    "Skin_Functionary1_EP1_DZ",
    "Skin_Priest_DZ",
    "Skin_Rocker1_DZ",
    "Skin_Rocker2_DZ",
    "Skin_Rocker3_DZ",
    "Skin_Rocker4_DZ",
    "Skin_Bandit1_DZ",
    "Skin_Bandit2_DZ",
    "Skin_Bandit3_DZ",
    "Skin_Bandit4_DZ",
    "Skin_Bandit5_DZ",
    "Skin_GUE_Soldier_MG_DZ",
    "Skin_GUE_Soldier_Sniper_DZ",
    "Skin_GUE_Soldier_Crew_DZ",
    "Skin_GUE_Soldier_CO_DZ",
    "Skin_GUE_Soldier_2_DZ",
    "Skin_BanditW1_DZ",
    "Skin_BanditW2_DZ",
    "Skin_SurvivorW3_DZ",
    "Skin_SurvivorW2_DZ",
    "Skin_SurvivorWpink_DZ",
    "Skin_SurvivorWcombat_DZ",
    "Skin_SurvivorWwinter_DZ",
    "Skin_SurvivorWdesert_DZ",
    "Skin_SurvivorWurban_DZ",
    "Skin_TK_INS_Warlord_EP1_DZ",
    "Skin_TK_INS_Soldier_EP1_DZ",
    "Skin_TK_INS_Soldier_EP2_DZ",
    "Skin_TK_INS_Soldier_EP3_DZ",
    "Skin_CZ_Special_Forces_GL_DES_EP1_DZ",
    "Skin_Drake_Light_DZ",
    "Skin_Soldier_Bodyguard_AA12_PMC_DZ",
    "Skin_FR_OHara_DZ",
    "Skin_FR_Rodriguez_DZ",
    "Skin_CZ_Soldier_Sniper_EP1_DZ",
    "Skin_Graves_Light_DZ",
    "Skin_Soldier_Sniper_PMC_DZ",
    "Skin_Soldier_TL_PMC_DZ",
    "Skin_TK_Special_Forces_MG_EP1_DZ",
    "Skin_TK_Soldier_Sniper_EP1_DZ",
    "Skin_TK_Commander_EP1_DZ",
    "Skin_RU_Soldier_Crew_DZ",
    "Skin_INS_Lopotev_DZ",
    "Skin_INS_Soldier_AR_DZ",
    "Skin_INS_Soldier_CO_DZ",
    "Skin_INS_Bardak_DZ",
    "Skin_INS_Worker2_DZ",
    "Skin_USMC_Soldier_Officer_DZ",
    "Skin_USMC_Soldier_MG_DZ",
    "Skin_USMC_Soldier_Pilot_DZ",
    "Skin_FR_TL_DZ",
    "Skin_FR_R_DZ",
    "Skin_FR_Marksman_DZ",
    "Skin_FR_Assault_R_DZ",
    "Skin_RU_Soldier_DZ",
    "Skin_RU_Soldier_Officer_DZ",
    "Skin_RUS_Soldier1_DZ",
    "Skin_RUS_Commander_DZ",
    "Skin_MVD_Soldier_DZ",
    "Skin_Ins_Soldier_2_DZ",
    "Skin_Ins_Commander_DZ",
    "Skin_Ins_Soldier_Crew_DZ",
    "Skin_CDF_Soldier_DZ",
    "Skin_Assistant_DZ",
    "Skin_Doctor_DZ",
    "Skin_Worker1_DZ",
    "Skin_Worker3_DZ",
    "Skin_Worker4_DZ",
    "Skin_TK_CIV_Takistani01_EP1_DZ",
    "Skin_TK_CIV_Takistani03_EP1_DZ",
    "Skin_TK_CIV_Takistani04_EP1_DZ",
    "Skin_TK_CIV_Takistani06_EP1_DZ",
    "Skin_TK_INS_Soldier_AR_EP1_DZ",
    "Skin_TK_GUE_Soldier_EP1_DZ",
    "Skin_CZ_Soldier_SL_DES_EP1_DZ",
    "Skin_US_Soldier_EP1_DZ",
    "Skin_UN_CDF_Soldier_EP1_DZ",
    "Skin_UN_CDF_Soldier_Guard_EP1_DZ",
    "Skin_GER_Soldier_TL_EP1_DZ",
    "Skin_BAF_Soldier_Officer_MTP_DZ",
    "Skin_BAF_Soldier_N_MTP_DZ",
    "Skin_FR_Sapper_DZ",
    "Skin_CamoWinter1_DZ",
    "Skin_CamoWinter2_DZ",
    "Skin_SniperWinter_DZ",
    "Skin_Nac_Soldier_DZ",
    "Skin_Tamika_DZ",
    "Skin_gsc_military_helmet_wdl_DZ",
    "Skin_gsc_military_head_wdl_DZ",
    "Skin_gsc_military_helmet_grey_DZ",
    "Skin_gsc_military_head_grey_DZ",
    "Skin_gsc_scientist1_DZ",
    "Skin_gsc_scientist1_head_DZ",
    "Skin_gsc_scientist2_DZ",
    "Skin_gsc_scientist2_head_DZ",
    "Skin_gsc_cloth_loner_head_DZ",
    "Skin_gsc_eco_stalker_mask_neutral_DZ",
    "Skin_gsc_eco_stalker_head_neutral_DZ",
    "Skin_gsc_eco_stalker_mask_fred_DZ",
    "Skin_gsc_eco_stalker_head_fred_DZ",
    "Skin_gsc_eco_stalker_mask_duty_DZ",
    "Skin_gsc_eco_stalker_head_duty_DZ",
    "Skin_gsc_eco_stalker_mask_camo_DZ",
    "Skin_gsc_eco_stalker_head_camo_DZ",
    "Skin_GhillieFull_Desert01_DZ",
    "Skin_GhillieFull_Desert02_DZ",
    "Skin_GhillieFull_Desert03_DZ",
    "Skin_GhillieFull_Desert04_DZ",
    "Skin_GhillieFull_Desert05_DZ",
    "Skin_GhillieFull_Desert06_DZ",
    "Skin_GhillieFull_Desert07_DZ",
    "Skin_GhillieFull_Desert08_DZ",
    "Skin_GhillieFull_Snow01_DZ",
    "Skin_GhillieFull_Snow02_DZ",
    "Skin_GhillieFull_Snow03_DZ",
    "Skin_GhillieFull_Snow04_DZ",
    "Skin_GhillieFull_Snow05_DZ",
    "Skin_GhillieFull_Urban01_DZ",
    "Skin_GhillieFull_Wood01_DZ",
    "Skin_GhillieFull_Wood02_DZ",
    "Skin_GhillieFull_Wood03_DZ",
    "Skin_GhillieFull_Wood04_DZ",
    "Skin_GhillieFull_Wood05_DZ",
    "Skin_GhillieFull_Wood06_DZ",
    "Skin_GhillieFull_Wood07_DZ",
    "Skin_GhillieFull_Wood08_DZ",
    "Skin_GhillieFull_Wood09_DZ",
    "Skin_GhillieFull_Wood10_DZ",
    "Skin_GhillieFull_Wood11_DZ",
    "Skin_GhillieFull_Wood12_DZ",
    "Skin_GhillieFull_Wood13_DZ",
    "Skin_GhillieFull_Wood14_DZ",
    "Skin_GhillieFull_Wood15_DZ",
    "Skin_GhillieFull_Wood16_DZ",
    "Skin_GER_Soldier_EP1_des_DZ",
    "Skin_GER_Soldier_TL_EP1_des_DZ",
    "Skin_GER_Soldier_EP1_wdl_DZ",
    "Skin_GER_Soldier_TL_EP1_wdl_DZ",
    "Skin_Apo_Rifleman_01_DZ",
    "Skin_Apo_Rifleman_02_DZ",
    "Skin_Apo_Rifleman_03_DZ",
    "Skin_Apo_Rifleman_04_DZ",
    "Skin_Apo_Rifleman_05_DZ",
    "Skin_Apo_Rifleman_06_DZ",
    "Skin_SG_GRU_TL_DZ",
    "Skin_SG_GRU_Scout_DZ",
    "Skin_SG_GRU_Sniper_DZ",
    "Skin_SG_GRU_Spotter_DZ",
    "Skin_SG_GRU_TL_W_DZ",
    "Skin_SG_GRU_Scout_W_DZ",
    "Skin_SG_GRU_Assaultman_W_DZ",
    "Skin_SG_GRU_Medic_W_DZ",
    "Skin_SG_GRU_TL_D_DZ",
    "Skin_SG_GRU_Scout_D_DZ",
    "Skin_SG_GRU_Marksman_D_DZ",
    "Skin_SG_GRU_Operator_D_DZ",
    "Skin_SG_GRU_MG_D_DZ",
    "Skin_CZ_Soldier805_DES_ACR_DZ",
    "Skin_CZ_Soldier_805_Wdl_ACR_DZ",
    "Skin_CZ_Soldier_Crew_Dst_ACR_DZ",
    "Skin_CZ_Soldier_Officer_Wdl_ACR_DZ",
    "Skin_CZ_Soldier_Recon_Wdl_ACR_DZ",
    "Skin_CZ_Soldier_Spec1_Wdl_ACR_DZ",
    "Skin_CZ_Soldier_Spec2_Wdl_ACR_DZ",
    "Skin_CZ_Soldier_Spec3_Wdl_ACR_DZ",
    "Skin_CZ_Soldier_Spec_Demo_Dst_ACR_DZ",
    "Skin_CZ_Soldier_Sniper_ACR_DZ",
    "Skin_CZ_Soldier_Light_Wdl_ACR_DZ",
    "Skin_Firefighter1_DZ",
    "Skin_Firefighter2_DZ",
    "Skin_Firefighter3_DZ",
    "Skin_Firefighter4_DZ",
    "Skin_Firefighter5_DZ",
    "Skin_Firefighter_Officer1_DZ",
    "Skin_Firefighter_Officer2_DZ",
    "Skin_Postman1_DZ",
    "Skin_Postman2_DZ",
    "Skin_Postman3_DZ",
    "Skin_Postman4_DZ",
    "Skin_SchoolTeacher_DZ",
    "Skin_Gardener_DZ",
    "Skin_Hunter_DZ",
    "Skin_Civilian1_DZ",
    "Skin_Civilian2_DZ",
    "Skin_Civilian3_DZ",
    "Skin_Civilian4_DZ",
    "Skin_Civilian5_DZ",
    "Skin_Civilian6_DZ",
    "Skin_Civilian7_DZ",
    "Skin_Civilian8_DZ",
    "Skin_Civilian9_DZ",
    "Skin_Civilian10_DZ",
    "Skin_Civilian11_DZ",
    "Skin_Civilian12_DZ",
    "Skin_Civilian13_DZ",
    "Skin_Civilian14_DZ",
    "Skin_Prisoner1_DZ",
    "Skin_Prisoner2_DZ",
    "Skin_Prisoner3_DZ",
    "Skin_Reporter_DZ",
    "Skin_MafiaBoss_DZ",
    "Skin_Dealer_DZ",
    "Skin_BusinessMan_DZ",
    "Skin_SniperW_DZ",
    "Skin_Sniper1W_DZ",
    "Skin_SniperBanditW_DZ",
    "Skin_CZ_Soldier_Sniper_EP1W_DZ",
    "Skin_SniperWinterW_DZ",
    "Skin_TK_Soldier_Sniper_EP1W_DZ",
    "Skin_CZ_Soldier_Sniper_ACRW_DZ",
    "Skin_GhillieFull_Desert01W_DZ",
    "Skin_GhillieFull_Desert02W_DZ",
    "Skin_GhillieFull_Desert03W_DZ",
    "Skin_GhillieFull_Desert04W_DZ",
    "Skin_GhillieFull_Desert05W_DZ",
    "Skin_GhillieFull_Desert06W_DZ",
    "Skin_GhillieFull_Desert07W_DZ",
    "Skin_GhillieFull_Desert08W_DZ",
    "Skin_GhillieFull_Snow01W_DZ",
    "Skin_GhillieFull_Snow02W_DZ",
    "Skin_GhillieFull_Snow03W_DZ",
    "Skin_GhillieFull_Snow04W_DZ",
    "Skin_GhillieFull_Snow05W_DZ",
    "Skin_GhillieFull_Urban01W_DZ",
    "Skin_GhillieFull_Wood01W_DZ",
    "Skin_GhillieFull_Wood02W_DZ",
    "Skin_GhillieFull_Wood03W_DZ",
    "Skin_GhillieFull_Wood04W_DZ",
    "Skin_GhillieFull_Wood05W_DZ",
    "Skin_GhillieFull_Wood06W_DZ",
    "Skin_GhillieFull_Wood07W_DZ",
    "Skin_GhillieFull_Wood08W_DZ",
    "Skin_GhillieFull_Wood09W_DZ",
    "Skin_GhillieFull_Wood10W_DZ",
    "Skin_GhillieFull_Wood11W_DZ",
    "Skin_GhillieFull_Wood12W_DZ",
    "Skin_GhillieFull_Wood13W_DZ",
    "Skin_GhillieFull_Wood14W_DZ",
    "Skin_GhillieFull_Wood15W_DZ",
    "Skin_GhillieFull_Wood16W_DZ",
    "Skin_gsc_military_helmet_wdlW_DZ",
    "Skin_gsc_military_helmet_greyW_DZ",
    "Skin_gsc_scientist1W_DZ",
    "Skin_gsc_scientist2W_DZ",
    "Skin_gsc_eco_stalker_mask_neutralW_DZ",
    "Skin_gsc_eco_stalker_mask_fredW_DZ",
    "Skin_gsc_eco_stalker_mask_dutyW_DZ",
    "Skin_gsc_eco_stalker_mask_camoW_DZ",
    "Skin_Nac_SoldierW_DZ",
    "Skin_CamoWinter1W_DZ",
    "Skin_CamoWinter2W_DZ",
    "Skin_DoctorW_DZ",
    "Skin_WorkerW_DZ",
    "Skin_PolicemanW_DZ",
    "Skin_PriestW_DZ",
    "Skin_HookerW_DZ",
    "Skin_OperatorW_DZ",
    "Skin_GunnerW_DZ",
    "bloodBagANEG",
    "bloodBagAPOS",
    "bloodBagBNEG",
    "bloodBagBPOS",
    "bloodBagABNEG",
    "bloodBagABPOS",
    "bloodBagONEG",
    "bloodBagOPOS",
    "wholeBloodBagANEG",
    "wholeBloodBagAPOS",
    "wholeBloodBagBNEG",
    "wholeBloodBagBPOS",
    "wholeBloodBagABNEG",
    "wholeBloodBagABPOS",
    "wholeBloodBagONEG",
    "wholeBloodBagOPOS",
    "bloodTester",
    "transfusionKit",
    "emptyBloodBag",
    "ItemBloodbag",
    "ItemBloodbagInfected",
    "ItemBloodbagZombie",
    "ItemBloodbagRabbit",
    "ItemBloodbagChicken",
    "ItemBloodbagDog",
    "ItemBloodbagCow",
    "ItemBloodbagBoar",
    "ItemBloodbagGoat",
    "ItemBloodbagSheep",
    "ItemAntibiotic",
    "ItemAntibiotic6",
    "ItemAntibiotic5",
    "ItemAntibiotic4",
    "ItemAntibiotic3",
    "ItemAntibiotic2",
    "ItemAntibiotic1",
    "ItemAntibioticEmpty",
    "ItemPainkiller",
    "ItemPainkiller6",
    "ItemPainkiller5",
    "ItemPainkiller4",
    "ItemPainkiller3",
    "ItemPainkiller2",
    "ItemPainkiller1",
    "ItemPainkillerEmpty",
    "ItemAntibacterialWipe",
    "ItemBandage",
    "ItemSepsisBandage",
    "ItemEpinephrine",
    "ItemMorphine",
    "ItemHeatPack",
    "equip_woodensplint",
    "equip_gauze",
    "equip_gauzepackaged",
    "equip_herb_box",
    "ItemBriefcase_Base",
    "ItemBriefcaseEmpty",
    "ItemBriefcase10oz",
    "ItemBriefcase20oz",
    "ItemBriefcase30oz",
    "ItemBriefcase40oz",
    "ItemBriefcase50oz",
    "ItemBriefcase60oz",
    "ItemBriefcase70oz",
    "ItemBriefcase80oz",
    "ItemBriefcase90oz",
    "ItemBriefcase100oz",
    "ItemSilvercase_Base",
    "ItemBriefcaseS10oz",
    "ItemBriefcaseS20oz",
    "ItemBriefcaseS30oz",
    "ItemBriefcaseS40oz",
    "ItemBriefcaseS50oz",
    "ItemBriefcaseS60oz",
    "ItemBriefcaseS70oz",
    "ItemBriefcaseS80oz",
    "ItemBriefcaseS90oz",
    "ItemBriefcaseS100oz",
    "ItemGoldBar",
    "ItemGoldBar2oz",
    "ItemGoldBar3oz",
    "ItemGoldBar4oz",
    "ItemGoldBar5oz",
    "ItemGoldBar6oz",
    "ItemGoldBar7oz",
    "ItemGoldBar8oz",
    "ItemGoldBar9oz",
    "ItemGoldBar10oz",
    "ItemSilverBar",
    "ItemSilverBar2oz",
    "ItemSilverBar3oz",
    "ItemSilverBar4oz",
    "ItemSilverBar5oz",
    "ItemSilverBar6oz",
    "ItemSilverBar7oz",
    "ItemSilverBar8oz",
    "ItemSilverBar9oz",
    "ItemSilverBar10oz",
    "ItemCopperBar",
    "ItemCopperBar10oz",
    "ItemAluminumBar",
    "ItemAluminumBar10oz",
    "ItemTinBar",
    "ItemTinBar10oz",
    "HandRoadFlare",
    "HandChemBlue",
    "HandChemGreen",
    "HandChemRed",
    "bulk",
    "bulk_empty",
    "bulk_ItemSodaCoke",
    "bulk_ItemSodaCokeFull",
    "bulk_ItemSodaPepsi",
    "bulk_ItemSodaPepsiFull",
    "bulk_FoodbaconCooked",
    "bulk_FoodbaconCookedFull",
    "bulk_equip_garlic_bulbFull",
    "bulk_FishCookedSeaBassFull",
    "bulk_FishCookedTroutFull",
    "bulk_FishCookedTunaFull",
    "bulk_FoodBeefCookedFull",
    "bulk_FoodCarrotFull",
    "bulk_FoodChickenCookedFull",
    "bulk_FoodDogCookedFull",
    "bulk_FoodGoatCookedFull",
    "bulk_FoodMuttonCookedFull",
    "bulk_FoodPotatoRawFull",
    "bulk_FoodPumpkinFull",
    "bulk_FoodRabbitCookedFull",
    "bulk_ItemSandbagHalf",
    "bulk_ItemSandbag",
    "bulk_ItemTankTrapHalf",
    "bulk_ItemTankTrap",
    "bulk_ItemWireHalf",
    "bulk_ItemWire",
    "bulk_PartGenericHalf",
    "bulk_PartGeneric",
    "bulk_ItemComboLockFull",
    "bulk_equip_aa_batteryFull",
    "bulk_equip_d_batteryFull",
    "bulk_equip_duct_tapeFull",
    "bulk_equip_feathersFull",
    "bulk_equip_floppywireFull",
    "bulk_equip_nailsFull",
    "bulk_equip_pvc_boxFull",
    "bulk_equip_ragFull",
    "bulk_equip_ropeFull",
    "bulk_equip_scrapelectronicsFull",
    "bulk_equip_stringFull",
    "bulk_HandChemBlueFull",
    "bulk_HandChemGreenFull",
    "bulk_HandChemRedFull",
    "bulk_HandRoadFlareFull",
    "bulk_ItemC4ChargeFull",
    "bulk_ItemDogTagFull",
    "bulk_ItemHotwireKitFull",
    "bulk_ItemKosmosSmokesFull",
    "bulk_ItemLightBulbFull",
    "bulk_ItemMixOilFull",
    "bulk_ItemScrewsFull",
    "bulk_PartGlassFull",
    "bulk_PartWheelFull",
    "bulk_PipeBombFull",
    "bulk_ItemFertilizerFull",
    "bulk_ItemKiloBlackTeaFull",
    "bulk_ItemKiloHempFull",
    "bulk_ItemKiloTobaccoFull",
    "bulk_ItemAnimalSkinFull",
    "bulk_ItemSkinRabbitFull",
    "bulk_ItemSkinCowFull",
    "bulk_ItemSkinGoatFull",
    "bulk_ItemSkinBoarFull",
    "bulk_ItemSkinDogFull",
    "bulk_ItemSkinSheepFull",
    "bulk_ItemWoolFull",
    "bulk_ItemLeatherFull",
    "bulk_17Rnd_9x19_glock17",
    "bulk_15Rnd_9x19_M9SD",
    "bulk_30Rnd_9x19_MP5SD",
    "bulk_30Rnd_556x45_StanagSD",
    "ItemTopaz",
    "ItemObsidian",
    "ItemSapphire",
    "ItemAmethyst",
    "ItemEmerald",
    "ItemCitrine",
    "ItemRuby",
    "PartOre",
    "PartOreSilver",
    "PartOreGold",
    "ItemMixOil",
    "CSGAS",
    "ItemJerryMixed",
    "ItemJerryMixed4",
    "ItemJerryMixed3",
    "ItemJerryMixed2",
    "ItemJerryMixed1",
    "ItemDocument",
    "ItemPlotDeed",
    "ItemLetter",
    "ItemBook1",
    "ItemBook2",
    "ItemBook3",
    "ItemBook4",
    "ItemNewspaper",
    "ItemDocumentRamp",
    "ItemBookBible",
    "ItemTrashPaper",
    "ItemTrashPaperMusic",
    "equip_paper_sheet",
    "equip_note",
    "ItemORP",
    "ItemAVE",
    "ItemLRK",
    "ItemTNK",
    "ItemARM",
    "ItemTruckORP",
    "ItemTruckAVE",
    "ItemTruckLRK",
    "ItemTruckTNK",
    "ItemTruckARM",
    "ItemTankORP",
    "ItemTankAVE",
    "ItemTankLRK",
    "ItemTankTNK",
    "ItemHeliAVE",
    "ItemHeliLRK",
    "ItemHeliTNK",
    "Blueprint_01",
    "Blueprint_02",
    "Blueprint_03",
    "Blueprint_04",
    "Blueprint_05",
    "Blueprint_06",
    "Blueprint_07",
    "Blueprint_08",
    "Blueprint_09",
    "Blueprint_10",
    "Blueprint_11",
    "Blueprint_12",
    "Blueprint_13",
    "Blueprint_14",
    "Blueprint_15",
    "Blueprint_16",
    "Blueprint_17",
    "Blueprint_18",
    "Blueprint_19",
    "Blueprint_20",
    "PileBooks",
    "PileMedBooks",
    "ItemC4Charge",
    "ItemCarBomb",
    "ItemJerrycanEmpty",
    "ItemJerrycan",
    "ItemFuelcanEmpty",
    "ItemFuelcan",
    "ItemFuelBarrel",
    "ItemFuelBarrelEmpty",
    "ItemOilBarrel",
    "ItemOilBarrelEmpty",
    "ItemMethylaminBarrelEmpty",
    "ItemMethylaminBarrel",
    "equip_lever",
    "ItemSledgeHead",
    "ItemSledgeHandle",
    "equip_Crossbow_Kit",
    "equip_crossbow_stock",
    "equip_paint",
    "equip_paint_generic",
    "equip_paint_black",
    "equip_paint_white",
    "equip_paint_blue",
    "equip_paint_green",
    "equip_paint_red",
    "ItemFertilizer",
    "ItemPumpkinPlant",
    "ItemHempSeed",
    "ItemHempPlant",
    "ItemKiloHemp",
    "ItemKiloTobacco",
    "ItemTobaccoSeed",
    "ItemKiloBlackTea",
    "ItemBlackTeaSeed",
    "ItemTobaccoLeafs",
    "equip_comfreyleafs",
    "ItemLog",
    "ItemPlank",
    "PartWoodPile",
    "PartPlankPack",
    "PartPlywoodPack",
    "PartWoodLumber",
    "PartWoodPlywood",
    "equip_wood_pallet",
    "equip_crate",
    "PartGeneric",
    "ItemPole",
    "ItemMetalSheet",
    "equip_metal_sheet",
    "equip_metal_sheet_rusted",
    "ItemRSJ",
    "equip_1inch_metal_pipe",
    "equip_2inch_metal_pipe",
    "equip_tent_poles",
    "ItemStone",
    "ItemConcreteBlock",
    "CinderBlocks",
    "MortarBucket",
    "equip_brick",
    "CementBag",
    "ItemCanvas",
    "ItemBurlap",
    "equip_rag",
    "equip_string",
    "equip_rope",
    "equip_aa_battery",
    "equip_aa_battery_empty",
    "equip_d_battery",
    "equip_d_battery_empty",
    "equip_floppywire",
    "equip_satawire",
    "equip_scrapelectronics",
    "equip_graphicscard",
    "equip_graphicscard_broken",
    "equip_soundcard",
    "equip_soundcard_broken",
    "equip_pcicard",
    "equip_pcicard_broken",
    "ItemLightBulb",
    "ItemLightBulbBroken",
    "ItemNotebook",
    "ItemNotebookBroken",
    "ItemSmallTV",
    "ItemSmallTVBroken",
    "ItemBigTV",
    "ItemBigTVBroken",
    "ItemSatelitePhone",
    "ItemSatelitePhoneBroken",
    "ItemPC",
    "ItemPCBroken",
    "ItemDesktopRadio",
    "ItemDesktopRadioBroken",
    "ItemMusicRadio1",
    "ItemMusicRadio1Broken",
    "ItemMusicRadio2",
    "ItemMusicRadio2Broken",
    "ItemComboLock",
    "ItemPadlock",
    "PartFueltank",
    "PartWheel",
    "PartEngine",
    "PartVRotor",
    "PartGlass",
    "PartFueltankBroken",
    "PartWheelBroken",
    "PartEngineBroken",
    "PartVRotorBroken",
    "PartGlassBroken",
    "ItemDogTag",
    "ItemDogTagHero",
    "ItemDogTagBandit",
    "ItemZombieParts",
    "ItemZombieHead",
    "ItemZombieLeg",
    "ItemZombieArm",
    "ItemZombieBrain",
    "ItemZombieHand",
    "ItemZombieFinger",
    "ItemZombieFoot",
    "ItemZombieToe",
    "ItemZombieLiver",
    "ItemZombieHeart",
    "ItemZombieEyes",
    "ItemZombieTongue",
    "ItemZombieTeeth",
    "ItemZombieskin",
    "ItemSkinRabbit",
    "ItemSkinCow",
    "ItemSkinGoat",
    "ItemSkinBoar",
    "ItemSkinDog",
    "ItemSkinSheep",
    "ItemWool",
    "ItemAnimalSkin",
    "ItemLeather",
    "ItemHotwireKit",
    "ItemCards",
    "ItemKosmosSmokes",
    "ItemKosmosSmokesOpen",
    "equip_nails",
    "ItemScrews",
    "equip_duct_tape",
    "equip_feathers",
    "equip_pvc_box",
    "equip_hobo_fishing_kit",
    "equip_hose",
    "equip_hose_clamp",
    "Item_coni",
    "Item_Connector_I",
    "Item_Connector_L",
    "Item_Connector_T",
    "equip_tin_powder",
    "equip_slugsinacan",
    "ItemBucket",
    "ItemSuitcase",
    "ItemSuitcaseDiamonds",
    "ItemSuitcaseBomb",
    "ItemPlasticParts",
    "ItemCeramicParts",
    "equip_cable_tie",
    "equip_needle",
    "equip_laser",
    "equip_weapon_rails",
    "equip_rail_screws",
    "TrapBear",
    "ItemTrapBearTrapFlare",
    "ItemTrapBearTrapSmoke",
    "ItemTrapTripwireCans",
    "ItemTrapTripwireFlare",
    "ItemTrapTripwireGrenade",
    "ItemTrapTripwireSmoke",
    "desert_large_net_kit",
    "forest_large_net_kit",
    "desert_net_kit",
    "forest_net_kit",
    "winter_net_kit",
    "winter_large_net_kit",
    "ItemSandbag",
    "BagFenceRound_DZ_kit",
    "ItemSandbagLarge",
    "ItemSandbagExLarge",
    "ItemSandbagExLarge5x",
    "sandbag_nest_kit",
    "glass_floor_kit",
    "glass_floor_half_kit",
    "glass_floor_quarter_kit",
    "metal_floor_kit",
    "metal_floor_half_kit",
    "metal_floor_quarter_kit",
    "metal_floor4x_kit",
    "metal_pillar_kit",
    "half_cinder_wall_kit",
    "half_cinder_wall_gap_kit",
    "full_cinder_wall_kit",
    "cinderwall_window_kit",
    "cinderwall_window_locked_kit",
    "cinder_door_frame_kit",
    "cinder_door_kit",
    "cinder_door_kit_locked",
    "cinder_door_hatch_kit",
    "cinder_door_hatch_kit_locked",
    "cinder_garage_frame_kit",
    "cinder_garage_kit",
    "cinder_garage_kit_locked",
    "cinder_garage_top_open_frame_kit",
    "cinder_garage_top_open_kit",
    "cinder_garage_top_open_kit_locked",
    "cinder_gate_frame_kit",
    "cinder_gate_kit",
    "cinder_gate_kit_locked",
    "cinder_bunker_kit",
    "cinder_bunker_kit_locked",
    "metal_drawbridge_kit",
    "metal_drawbridge_kit_locked",
    "ItemWoodFloor",
    "ItemWoodFloor4x",
    "ItemWoodFloorStairs",
    "ItemTriangleWoodFloor",
    "ItemWoodFloorHalf",
    "ItemWoodFloorQuarter",
    "ItemWoodStairs",
    "ItemWoodStairsSupport",
    "ItemWoodLadder",
    "ItemWoodHandRail",
    "ItemWoodPillar",
    "ItemWoodWall",
    "ItemTriangleWoodWall",
    "ItemWoodWallThird",
    "ItemWoodWallWindow",
    "ItemWoodWallDoor",
    "ItemWoodWallWithDoor",
    "ItemWoodWallWithDoorLocked",
    "ItemWoodWallGarageDoor",
    "ItemWoodWallGarageDoorLocked",
    "ItemWoodOpenTopGarageDoor",
    "ItemWoodOpenTopGarageDoorLocked",
    "ItemWoodWallLg",
    "ItemWoodWallWindowLg",
    "ItemWoodWallDoorLg",
    "ItemWoodWallWithDoorLg",
    "ItemWoodWallWithDoorLgLocked",
    "ItemWoodGateFrame",
    "ItemWoodGate",
    "ItemWoodGateLocked",
    "door_frame_kit",
    "door_kit",
    "door_locked_kit",
    "woodfence_foundation_kit",
    "woodfence_frame_kit",
    "woodfence_quaterpanel_kit",
    "woodfence_halfpanel_kit",
    "woodfence_thirdpanel_kit",
    "woodfence_1_kit",
    "woodfence_2_kit",
    "woodfence_3_kit",
    "woodfence_4_kit",
    "woodfence_5_kit",
    "woodfence_6_kit",
    "woodfence_7_kit",
    "metalfence_foundation_kit",
    "metalfence_frame_kit",
    "metalfence_halfpanel_kit",
    "metalfence_thirdpanel_kit",
    "metalfence_1_kit",
    "metalfence_2_kit",
    "metalfence_3_kit",
    "metalfence_4_kit",
    "metalfence_5_kit",
    "metalfence_6_kit",
    "metalfence_7_kit",
    "woodfence_gate_foundation_kit",
    "woodfence_gate_1_kit",
    "woodfence_gate_2_kit",
    "woodfence_gate_3_kit",
    "woodfence_gate_4_kit",
    "outhouse_kit",
    "wooden_shed_kit",
    "wooden_shed_kit2",
    "wood_shack_kit",
    "wood_shack_kit2",
    "storage_shed_kit",
    "storage_shed_kit2",
    "ItemGunRackKit",
    "ItemGunRackKit2",
    "ItemWoodCrateKit",
    "ItemWoodCrateKit2",
    "ItemVault",
    "ItemVault2",
    "ItemTallSafe",
    "ItemLockbox",
    "ItemLockbox2",
    "ItemLockboxWinter",
    "ItemLockboxWinter2",
    "ItemVaultBroken",
    "ItemVault2Broken",
    "ItemTallSafeBroken",
    "ItemLockboxBroken",
    "ItemLockbox2Broken",
    "ItemLockboxWinterBroken",
    "ItemLockboxWinter2Broken",
    "StashSmall_kit",
    "cook_tripod_kit",
    "stoneoven_kit",
    "commode_kit",
    "wardrobe_kit",
    "fridge_kit",
    "washing_machine_kit",
    "server_rack_kit",
    "atm_kit",
    "armchair_kit",
    "sofa_kit",
    "arcade_kit",
    "vendmachine1_kit",
    "vendmachine2_kit",
    "storage_crate_kit",
    "camo_storage_crate_kit",
    "ItemTent",
    "ItemTentWinter",
    "ItemDomeTent",
    "ItemWinterDomeTent",
    "ItemDesertTent",
    "ItemFireBarrel_kit",
    "workbench_kit",
    "advanced_workBench_kit",
    "ItemWorkBench",
    "wood_ramp_kit",
    "plot_pole_kit",
    "metal_panel_kit",
    "ItemCorrugated",
    "ItemWire",
    "ItemTankTrap",
    "ItemGenerator",
    "fuel_pump_kit",
    "light_pole_kit",
    "deer_stand_kit",
    "m240_nest_kit",
    "rusty_gate_kit",
    "stick_fence_kit",
    "sun_shade_kit",
    "park_bench_kit",
    "ItemScaffoldingKit",
    "notebook_kit",
    "water_pump_kit",
    "greenhouse_kit",
    "bed_kit",
    "table_kit",
    "office_chair_kit",
    "garage_green_kit",
    "garage_white_kit",
    "garage_brown_kit",
    "garage_grey_kit",
    "helipad_civil_kit",
    "helipad_rescue_kit",
    "helipad_army_kit",
    "helipad_cross_kit",
    "helipad_parkborder_kit",
    "cctv_kit",
  ],
  weaponClasses: [
    "Anzio_20",
    "RedRyder",
    "M9",
    "M9SD",
    "Makarov",
    "MakarovSD",
    "M16A2",
    "M16A2GL",
    "m16a4",
    "m16a4_acg",
    "M16A4_GL",
    "M16A4_ACG_GL",
    "M24",
    "M40A3",
    "M240",
    "Mk_48",
    "M249",
    "M4A1",
    "M4A1_Aim",
    "M4A1_Aim_camo",
    "M4SPR",
    "M4A1_RCO_GL",
    "M4A1_AIM_SD_camo",
    "M4A1_HWS_GL_SD_Camo",
    "M4A1_HWS_GL",
    "M4A1_HWS_GL_camo",
    "MP5SD",
    "MP5A5",
    "PK",
    "Pecheneg",
    "SVD",
    "SVD_CAMO",
    "G36C",
    "G36_C_SD_eotech",
    "G36a",
    "G36K",
    "MG36",
    "M136",
    "Javelin",
    "Stinger",
    "RPG7V",
    "Strela",
    "Igla",
    "MetisLauncher",
    "Binocular",
    "Laserdesignator",
    "Laserdesignator_mounted",
    "NVGoggles",
    "SmokeLauncher",
    "FlareLauncher",
    "M134",
    "M134_2",
    "TwinM134",
    "TwinVickers",
    "2A72",
    "YakB",
    "GSh23L",
    "GSh302",
    "GSh301",
    "SPG9",
    "GRAD",
    "MLRS",
    "Kostey_photos",
    "Kostey_map_case",
    "Kostey_notebook",
    "CDF_dogtags",
    "Moscow_Bombing_File",
    "Cobalt_File",
    "ItemWatch",
    "ItemCompass",
    "ItemGPS",
    "ItemRadio",
    "ItemMap",
    "EvPhoto",
    "EvMap",
    "EvMoscow",
    "EvKobalt",
    "EvMoney",
    "EvDogTags",
    "AK_47_M",
    "AK_47_S",
    "AKS_GOLD",
    "AK_74",
    "AK_74_GL",
    "AK_107_kobra",
    "AK_107_GL_kobra",
    "AK_107_GL_pso",
    "AK_107_pso",
    "AKS_74_kobra",
    "AKS_74_pso",
    "AKS_74_U",
    "AKS_74_UN_kobra",
    "RPK_74",
    "bizon",
    "bizon_silenced",
    "Colt1911",
    "DMR",
    "ksvk",
    "M1014",
    "m107",
    "Saiga12K",
    "VSS_vintorez",
    "PMC_documents",
    "m8_carbine",
    "m8_carbineGL",
    "m8_compact",
    "m8_sharpshooter",
    "m8_SAW",
    "huntingrifle",
    "RPG18",
    "SMAW",
    "BAF_AS50_scoped",
    "BAF_AS50_TWS",
    "BAF_LRR_scoped",
    "BAF_LRR_scoped_W",
    "BAF_NLAW_Launcher",
    "BAF_L85A2_RIS_Holo",
    "BAF_L85A2_UGL_Holo",
    "BAF_L85A2_RIS_SUSAT",
    "BAF_L85A2_UGL_SUSAT",
    "BAF_L85A2_RIS_ACOG",
    "BAF_L85A2_UGL_ACOG",
    "BAF_L85A2_RIS_CWS",
    "BAF_L86A2_ACOG",
    "BAF_L110A1_Aim",
    "BAF_L7A2_GPMG",
    "CMFlareLauncher",
    "Sa61_EP1",
    "UZI_EP1",
    "UZI_SD_EP1",
    "revolver_EP1",
    "revolver_gold_EP1",
    "glock17_EP1",
    "M60A4_EP1",
    "Mk_48_DES_EP1",
    "M249_EP1",
    "M249_TWS_EP1",
    "M249_m145_EP1",
    "M24_des_EP1",
    "SVD_des_EP1",
    "SVD_NSPU_EP1",
    "Sa58P_EP1",
    "Sa58V_EP1",
    "Sa58V_RCO_EP1",
    "Sa58V_CCO_EP1",
    "M4A3_CCO_EP1",
    "M4A3_RCO_GL_EP1",
    "Binocular_Vector",
    "AK_74_GL_kobra",
    "AKS_74",
    "AKS_74_NSPU",
    "AKS_74_GOSHAWK",
    "FN_FAL",
    "FN_FAL_ANPVS4",
    "G36C_camo",
    "G36_C_SD_camo",
    "G36A_camo",
    "G36K_camo",
    "MG36_camo",
    "M32_EP1",
    "M79_EP1",
    "Mk13_EP1",
    "LeeEnfield",
    "m107_TWS_EP1",
    "M110_TWS_EP1",
    "M110_NVG_EP1",
    "M14_EP1",
    "m240_scoped_EP1",
    "M47Launcher_EP1",
    "MAAWS",
    "SCAR_L_CQC",
    "SCAR_L_CQC_Holo",
    "SCAR_L_STD_Mk4CQT",
    "SCAR_L_STD_EGLM_RCO",
    "SCAR_L_CQC_EGLM_Holo",
    "SCAR_L_STD_EGLM_TWS",
    "SCAR_L_STD_HOLO",
    "SCAR_L_CQC_CCO_SD",
    "SCAR_H_CQC_CCO",
    "SCAR_H_CQC_CCO_SD",
    "SCAR_H_STD_EGLM_Spect",
    "SCAR_H_LNG_Sniper",
    "SCAR_H_LNG_Sniper_SD",
    "SCAR_H_STD_TWS_SD",
    "AA12_PMC",
    "PMC_AS50_scoped",
    "PMC_AS50_TWS",
    "m8_carbine_pmc",
    "m8_compact_pmc",
    "m8_holo_sd",
    "m8_tws_sd",
    "m8_tws",
    "GSh23L_L39",
    "CZ_750_S1_ACR",
    "Evo_ACR",
    "Evo_mrad_ACR",
    "evo_sd_ACR",
    "GRAD_ACR",
    "CZ_75_P_07_DUTY",
    "CZ_75_D_COMPACT",
    "CZ_75_SP_01_PHANTOM",
    "CZ_75_SP_01_PHANTOM_SD",
    "CZ805_A1_ACR",
    "CZ805_A1_GL_ACR",
    "CZ805_A2_ACR",
    "CZ805_A2_SD_ACR",
    "CZ805_B_GL_ACR",
    "LRTV_ACR",
    "UK59_ACR",
    "pook_H13Grenades",
    "2A72_AI",
    "SPG9_AI",
    "MG36_Large",
    "MG36_camo_Large",
    "RPK_74_Large",
    "m8_SAW_Large",
    "BAF_AS50_scoped_Large",
    "BAF_AS50_TWS_Large",
    "PMC_AS50_scoped_Large",
    "PMC_AS50_TWS_Large",
    "M4A3_EP1",
    "BAF_L7A2_GPMG_Small",
    "BAF_L110A1_Aim_Small",
    "M60A4_EP1_Small",
    "M240_Small",
    "M249_Small",
    "M249_EP1_Small",
    "M249_TWS_EP1_Small",
    "M249_m145_EP1_Small",
    "Mk_48_Small",
    "Mk_48_DES_EP1_Small",
    "PK_Small",
    "Pecheneg_Small",
    "UK59_ACR_Small",
    "ksvk_Small",
    "m107_Small",
    "m107_TWS_EP1_Small",
    "m240_scoped_EP1_Small",
    "GSh302K",
    "AK_107_CP",
    "AK_107_GL_CP",
    "AKS_74_UN_CP",
    "M4A3_RCO_EP1",
    "ItemDIY_wood",
    "ItemDIY_Gate",
    "ItemDIY_metal",
    "AK74_Kobra_DZ",
    "AK74_Kobra_SD_DZ",
    "AK74_GL_Kobra_DZ",
    "AK74_GL_Kobra_SD_DZ",
    "AK74_DZ",
    "AK74_SD_DZ",
    "AK74_GL_DZ",
    "AK74_GL_SD_DZ",
    "AK74_PSO1_DZ",
    "AK74_PSO1_SD_DZ",
    "AK74_GL_PSO1_DZ",
    "AK74_GL_PSO1_SD_DZ",
    "AK107_Kobra_DZ",
    "AK107_DZ",
    "AK107_GL_DZ",
    "AK107_PSO_DZ",
    "AK107_GL_PSO_DZ",
    "AK107_GL_Kobra_DZ",
    "AN94_DZ",
    "AN94_GL_DZ",
    "AKS74U_Kobra_DZ",
    "AKS74U_Kobra_SD_DZ",
    "AKS74U_DZ",
    "AKS74U_SD_DZ",
    "AKM_DZ",
    "AKM_Kobra_DZ",
    "AKM_PSO1_DZ",
    "AKS_Gold_DZ",
    "AKS_Silver_DZ",
    "AKS_DZ",
    "RK95_DZ",
    "RK95_SD_DZ",
    "RK95_CCO_SD_DZ",
    "RK95_ACOG_SD_DZ",
    "RK95_CCO_DZ",
    "RK95_ACOG_DZ",
    "Groza9_DZ",
    "Groza9_Sniper_DZ",
    "Groza9_GL_DZ",
    "Groza9_GL_Sniper_DZ",
    "Groza9_SD_DZ",
    "Groza9_Sniper_SD_DZ",
    "Groza1_DZ",
    "Groza1_Sniper_DZ",
    "Groza1_SD_DZ",
    "Groza1_Sniper_SD_DZ",
    "SCAR_H_AK_DZ",
    "SCAR_H_AK_CCO_DZ",
    "SCAR_H_B_AK_CCO_DZ",
    "SCAR_H_AK_HOLO_DZ",
    "SCAR_H_AK_ACOG_DZ",
    "RPK_DZ",
    "RPK_Kobra_DZ",
    "RPK_PSO1_DZ",
    "DMR_DZ",
    "DMR_SKN",
    "DMR_Gh_DZ",
    "DMR_DZE",
    "DMR_Gh_DZE",
    "RSASS_DZ",
    "RSASS_TWS_DZ",
    "RSASS_SD_DZ",
    "RSASS_TWS_SD_DZ",
    "FNFAL_DZ",
    "FNFAL_CCO_DZ",
    "FNFAL_Holo_DZ",
    "FNFAL_ANPVS4_DZ",
    "FN_FAL_ANPVS4_DZE",
    "G3_DZ",
    "G36K_Camo_DZ",
    "G36K_Camo_SD_DZ",
    "G36A_Camo_DZ",
    "G36A_Camo_SD_DZ",
    "G36C_DZ",
    "G36C_SD_DZ",
    "G36C_CCO_DZ",
    "G36C_CCO_SD_DZ",
    "G36C_Holo_DZ",
    "G36C_Holo_SD_DZ",
    "G36C_ACOG_DZ",
    "G36C_ACOG_SD_DZ",
    "G36C_Camo_DZ",
    "G36C_Camo_Holo_SD_DZ",
    "MG36_DZ",
    "MG36_Camo_DZ",
    "M4A1_DZ",
    "M4A1_FL_DZ",
    "M4A1_MFL_DZ",
    "M4A1_SD_DZ",
    "M4A1_SD_FL_DZ",
    "M4A1_SD_MFL_DZ",
    "M4A1_GL_DZ",
    "M4A1_GL_FL_DZ",
    "M4A1_GL_MFL_DZ",
    "M4A1_GL_SD_DZ",
    "M4A1_GL_SD_FL_DZ",
    "M4A1_GL_SD_MFL_DZ",
    "M4A1_CCO_DZ",
    "M4A1_CCO_FL_DZ",
    "M4A1_CCO_MFL_DZ",
    "M4A1_CCO_SD_DZ",
    "M4A1_CCO_SD_FL_DZ",
    "M4A1_CCO_SD_MFL_DZ",
    "M4A1_GL_CCO_DZ",
    "M4A1_GL_CCO_FL_DZ",
    "M4A1_GL_CCO_MFL_DZ",
    "M4A1_GL_CCO_SD_DZ",
    "M4A1_GL_CCO_SD_FL_DZ",
    "M4A1_GL_CCO_SD_MFL_DZ",
    "M4A1_Holo_DZ",
    "M4A1_Holo_FL_DZ",
    "M4A1_Holo_MFL_DZ",
    "M4A1_Holo_SD_DZ",
    "M4A1_Holo_SD_FL_DZ",
    "M4A1_Holo_SD_MFL_DZ",
    "M4A1_GL_Holo_DZ",
    "M4A1_GL_Holo_FL_DZ",
    "M4A1_GL_Holo_MFL_DZ",
    "M4A1_GL_Holo_SD_DZ",
    "M4A1_GL_Holo_SD_FL_DZ",
    "M4A1_GL_Holo_SD_MFL_DZ",
    "M4A1_ACOG_DZ",
    "M4A1_ACOG_FL_DZ",
    "M4A1_ACOG_MFL_DZ",
    "M4A1_ACOG_SD_DZ",
    "M4A1_ACOG_SD_FL_DZ",
    "M4A1_ACOG_SD_MFL_DZ",
    "M4A1_GL_ACOG_DZ",
    "M4A1_GL_ACOG_FL_DZ",
    "M4A1_GL_ACOG_MFL_DZ",
    "M4A1_GL_ACOG_SD_DZ",
    "M4A1_GL_ACOG_SD_FL_DZ",
    "M4A1_GL_ACOG_SD_MFL_DZ",
    "M4A1_Rusty_DZ",
    "M4A1_Camo_CCO_DZ",
    "M4A1_Camo_CCO_SD_DZ",
    "M4A1_Camo_Holo_GL_DZ",
    "M4A1_Camo_Holo_GL_SD_DZ",
    "M4A3_DES_CCO_DZ",
    "M4A3_ACOG_GL_DZ",
    "M4A3_Camo_DZ",
    "M4A3_Camo_ACOG_DZ",
    "HK416_DZ",
    "HK416_SD_DZ",
    "HK416_GL_DZ",
    "HK416_GL_SD_DZ",
    "HK416_CCO_DZ",
    "HK416_CCO_SD_DZ",
    "HK416_GL_CCO_DZ",
    "HK416_GL_CCO_SD_DZ",
    "HK416_Holo_DZ",
    "HK416_Holo_SD_DZ",
    "HK416_GL_Holo_DZ",
    "HK416C_DZ",
    "HK416C_GL_DZ",
    "HK416C_CCO_DZ",
    "HK416C_GL_CCO_DZ",
    "HK416C_Holo_DZ",
    "HK416C_GL_Holo_DZ",
    "HK416C_ACOG_DZ",
    "HK416C_GL_ACOG_DZ",
    "SteyrAug_A3_Green_DZ",
    "SteyrAug_A3_Black_DZ",
    "SteyrAug_A3_Blue_DZ",
    "SteyrAug_A3_ACOG_Green_DZ",
    "SteyrAug_A3_ACOG_Black_DZ",
    "SteyrAug_A3_ACOG_Blue_DZ",
    "SteyrAug_A3_Holo_Green_DZ",
    "SteyrAug_A3_Holo_Black_DZ",
    "SteyrAug_A3_Holo_Blue_DZ",
    "SteyrAug_A3_GL_Green_DZ",
    "SteyrAug_A3_GL_Black_DZ",
    "SteyrAug_A3_GL_Blue_DZ",
    "SteyrAug_A3_ACOG_GL_Green_DZ",
    "SteyrAug_A3_ACOG_GL_Black_DZ",
    "SteyrAug_A3_ACOG_GL_Blue_DZ",
    "SteyrAug_A3_Holo_GL_Green_DZ",
    "SteyrAug_A3_Holo_GL_Black_DZ",
    "SteyrAug_A3_Holo_GL_Blue_DZ",
    "HK53A3_DZ",
    "HK53A3_CCO_DZ",
    "HK53A3_Holo_DZ",
    "PDR_DZ",
    "PDR_CCO_DZ",
    "PDR_Holo_DZ",
    "Famas_DZ",
    "Famas_CCO_DZ",
    "Famas_Holo_DZ",
    "Famas_SD_DZ",
    "Famas_CCO_SD_DZ",
    "Famas_Holo_SD_DZ",
    "ACR_WDL_DZ",
    "ACR_WDL_SD_DZ",
    "ACR_WDL_GL_DZ",
    "ACR_WDL_GL_SD_DZ",
    "ACR_WDL_CCO_DZ",
    "ACR_WDL_CCO_SD_DZ",
    "ACR_WDL_CCO_GL_DZ",
    "ACR_WDL_CCO_GL_SD_DZ",
    "ACR_WDL_Holo_DZ",
    "ACR_WDL_Holo_SD_DZ",
    "ACR_WDL_Holo_GL_DZ",
    "ACR_WDL_Holo_GL_SD_DZ",
    "ACR_WDL_ACOG_DZ",
    "ACR_WDL_ACOG_SD_DZ",
    "ACR_WDL_ACOG_GL_DZ",
    "ACR_WDL_ACOG_GL_SD_DZ",
    "ACR_WDL_TWS_DZ",
    "ACR_WDL_TWS_GL_DZ",
    "ACR_WDL_TWS_SD_DZ",
    "ACR_WDL_TWS_GL_SD_DZ",
    "ACR_WDL_NV_DZ",
    "ACR_WDL_NV_SD_DZ",
    "ACR_WDL_NV_GL_DZ",
    "ACR_WDL_NV_GL_SD_DZ",
    "ACR_BL_DZ",
    "ACR_BL_SD_DZ",
    "ACR_BL_GL_DZ",
    "ACR_BL_GL_SD_DZ",
    "ACR_BL_CCO_DZ",
    "ACR_BL_CCO_SD_DZ",
    "ACR_BL_CCO_GL_DZ",
    "ACR_BL_CCO_GL_SD_DZ",
    "ACR_BL_Holo_DZ",
    "ACR_BL_Holo_SD_DZ",
    "ACR_BL_Holo_GL_DZ",
    "ACR_BL_Holo_GL_SD_DZ",
    "ACR_BL_ACOG_DZ",
    "ACR_BL_ACOG_SD_DZ",
    "ACR_BL_ACOG_GL_DZ",
    "ACR_BL_ACOG_GL_SD_DZ",
    "ACR_BL_TWS_DZ",
    "ACR_BL_TWS_GL_DZ",
    "ACR_BL_TWS_SD_DZ",
    "ACR_BL_TWS_GL_SD_DZ",
    "ACR_BL_NV_DZ",
    "ACR_BL_NV_SD_DZ",
    "ACR_BL_NV_GL_DZ",
    "ACR_BL_NV_GL_SD_DZ",
    "ACR_DES_DZ",
    "ACR_DES_SD_DZ",
    "ACR_DES_GL_DZ",
    "ACR_DES_GL_SD_DZ",
    "ACR_DES_CCO_DZ",
    "ACR_DES_CCO_SD_DZ",
    "ACR_DES_CCO_GL_DZ",
    "ACR_DES_CCO_GL_SD_DZ",
    "ACR_DES_Holo_DZ",
    "ACR_DES_Holo_SD_DZ",
    "ACR_DES_Holo_GL_DZ",
    "ACR_DES_Holo_GL_SD_DZ",
    "ACR_DES_ACOG_DZ",
    "ACR_DES_ACOG_SD_DZ",
    "ACR_DES_ACOG_GL_DZ",
    "ACR_DES_ACOG_GL_SD_DZ",
    "ACR_DES_TWS_DZ",
    "ACR_DES_TWS_GL_DZ",
    "ACR_DES_TWS_SD_DZ",
    "ACR_DES_TWS_GL_SD_DZ",
    "ACR_DES_NV_DZ",
    "ACR_DES_NV_SD_DZ",
    "ACR_DES_NV_GL_DZ",
    "ACR_DES_NV_GL_SD_DZ",
    "ACR_SNOW_DZ",
    "ACR_SNOW_SD_DZ",
    "ACR_SNOW_GL_DZ",
    "ACR_SNOW_GL_SD_DZ",
    "ACR_SNOW_CCO_DZ",
    "ACR_SNOW_CCO_SD_DZ",
    "ACR_SNOW_CCO_GL_DZ",
    "ACR_SNOW_CCO_GL_SD_DZ",
    "ACR_SNOW_Holo_DZ",
    "ACR_SNOW_Holo_SD_DZ",
    "ACR_SNOW_Holo_GL_DZ",
    "ACR_SNOW_Holo_GL_SD_DZ",
    "ACR_SNOW_ACOG_DZ",
    "ACR_SNOW_ACOG_SD_DZ",
    "ACR_SNOW_ACOG_GL_DZ",
    "ACR_SNOW_ACOG_GL_SD_DZ",
    "ACR_SNOW_TWS_DZ",
    "ACR_SNOW_TWS_GL_DZ",
    "ACR_SNOW_TWS_SD_DZ",
    "ACR_SNOW_TWS_GL_SD_DZ",
    "ACR_SNOW_NV_DZ",
    "ACR_SNOW_NV_SD_DZ",
    "ACR_SNOW_NV_GL_DZ",
    "ACR_SNOW_NV_GL_SD_DZ",
    "KAC_PDW_DZ",
    "KAC_PDW_CCO_DZ",
    "KAC_PDW_HOLO_DZ",
    "KAC_PDW_ACOG_DZ",
    "CTAR21_DZ",
    "CTAR21_CCO_DZ",
    "CTAR21_ACOG_DZ",
    "Masada_DZ",
    "Masada_SD_DZ",
    "Masada_CCO_DZ",
    "Masada_CCO_SD_DZ",
    "Masada_Holo_DZ",
    "Masada_Holo_SD_DZ",
    "Masada_ACOG_DZ",
    "Masada_ACOG_SD_DZ",
    "Masada_BL_DZ",
    "Masada_BL_SD_DZ",
    "Masada_BL_CCO_DZ",
    "Masada_BL_CCO_SD_DZ",
    "Masada_BL_Holo_DZ",
    "Masada_BL_Holo_SD_DZ",
    "Masada_BL_ACOG_DZ",
    "Masada_BL_ACOG_SD_DZ",
    "MK16_DZ",
    "MK16_CCO_DZ",
    "MK16_Holo_DZ",
    "MK16_ACOG_DZ",
    "MK16_GL_DZ",
    "MK16_GL_CCO_DZ",
    "MK16_GL_Holo_DZ",
    "MK16_GL_ACOG_DZ",
    "MK16_CCO_SD_DZ",
    "MK16_Holo_SD_DZ",
    "MK16_ACOG_SD_DZ",
    "MK16_GL_CCO_SD_DZ",
    "MK16_GL_Holo_SD_DZ",
    "MK16_GL_ACOG_SD_DZ",
    "MK16_BL_CCO_DZ",
    "MK16_BL_GL_ACOG_DZ",
    "MK16_BL_Holo_SD_DZ",
    "MK16_BL_GL_CCO_SD_DZ",
    "XM8_DZ",
    "XM8_DES_DZ",
    "XM8_GREY_DZ",
    "XM8_GREY_2_DZ",
    "XM8_GL_DZ",
    "XM8_DES_GL_DZ",
    "XM8_GREY_GL_DZ",
    "XM8_Compact_DZ",
    "XM8_DES_Compact_DZ",
    "XM8_GREY_Compact_DZ",
    "XM8_GREY_2_Compact_DZ",
    "XM8_Sharpsh_DZ",
    "XM8_DES_Sharpsh_DZ",
    "XM8_GREY_Sharpsh_DZ",
    "XM8_SAW_DZ",
    "XM8_DES_SAW_DZ",
    "XM8_GREY_SAW_DZ",
    "XM8_SD_DZ",
    "M14_DZ",
    "M14_Gh_DZ",
    "M14_CCO_DZ",
    "M14_CCO_Gh_DZ",
    "M14_Holo_DZ",
    "M14_Holo_Gh_DZ",
    "M1A_SC16_BL_DZ",
    "M1A_SC16_BL_ACOG_DZ",
    "M1A_SC16_BL_CCO_DZ",
    "M1A_SC16_BL_HOLO_DZ",
    "M1A_SC16_BL_PU_DZ",
    "M1A_SC16_BL_Sniper_DZ",
    "M1A_SC16_TAN_DZ",
    "M1A_SC16_TAN_ACOG_DZ",
    "M1A_SC16_TAN_CCO_DZ",
    "M1A_SC16_TAN_HOLO_DZ",
    "M1A_SC16_TAN_PU_DZ",
    "M1A_SC16_TAN_Sniper_DZ",
    "M1A_SC2_BL_DZ",
    "M1A_SC2_BL_ACOG_DZ",
    "M1A_SC2_BL_CCO_DZ",
    "M1A_SC2_BL_HOLO_DZ",
    "M1A_SC2_BL_PU_DZ",
    "M1A_SC2_BL_Sniper_DZ",
    "M21_DZ",
    "M21A5_DZ",
    "M21A5_SD_DZ",
    "HK417_DZ",
    "HK417_SD_DZ",
    "HK417_CCO_DZ",
    "HK417_CCO_SD_DZ",
    "HK417_Holo_DZ",
    "HK417_Holo_SD_DZ",
    "HK417_ACOG_DZ",
    "HK417_ACOG_SD_DZ",
    "HK417C_DZ",
    "HK417C_GL_DZ",
    "HK417C_CCO_DZ",
    "HK417C_GL_CCO_DZ",
    "HK417C_Holo_DZ",
    "HK417C_GL_Holo_DZ",
    "HK417C_ACOG_DZ",
    "HK417C_GL_ACOG_DZ",
    "HK417_Sniper_DZ",
    "HK417_Sniper_SD_DZ",
    "MK14_DZ",
    "MK14_CCO_DZ",
    "MK14_Holo_DZ",
    "MK14_ACOG_DZ",
    "MK14_Sniper_DZ",
    "MK14_SD_DZ",
    "MK14_CCO_SD_DZ",
    "MK14_Holo_SD_DZ",
    "MK14_ACOG_SD_DZ",
    "MK14_Sniper_SD_DZ",
    "MK17_DZ",
    "MK17_CCO_DZ",
    "MK17_Holo_DZ",
    "MK17_ACOG_DZ",
    "MK17_GL_DZ",
    "MK17_GL_CCO_DZ",
    "MK17_GL_Holo_DZ",
    "MK17_GL_ACOG_DZ",
    "MK17_CCO_SD_DZ",
    "MK17_Holo_SD_DZ",
    "MK17_ACOG_SD_DZ",
    "MK17_GL_CCO_SD_DZ",
    "MK17_GL_Holo_SD_DZ",
    "MK17_BL_Holo_DZ",
    "MK17_BL_GL_ACOG_DZ",
    "MK17_BL_CCO_SD_DZ",
    "MK17_BL_GL_Holo_SD_DZ",
    "MK17_Sniper_DZ",
    "MK17_Sniper_SD_DZ",
    "M110_NV_DZ",
    "CZ805_A1_DZ",
    "CZ805_A1_GL_DZ",
    "CZ805_A2_DZ",
    "CZ805_A2_SD_DZ",
    "CZ805_B_GL_DZ",
    "M24_DZ",
    "M24_Gh_DZ",
    "M24_DES_DZ",
    "M40A3_Gh_DZ",
    "M40A3_DZ",
    "CZ750_DZ",
    "M249_CCO_DZ",
    "M249_DZ",
    "M249_Holo_DZ",
    "M249_EP1_DZ",
    "M249_m145_EP1_DZE",
    "L110A1_CCO_DZ",
    "L110A1_Holo_DZ",
    "L110A1_DZ",
    "BAF_L110A1_Aim_DZE",
    "M240_DZ",
    "M240_CCO_DZ",
    "M240_Holo_DZ",
    "m240_scoped_EP1_DZE",
    "M60A4_EP1_DZE",
    "Mk43_DZ",
    "MK43_Holo_DZ",
    "MK43_ACOG_DZ",
    "MK43_M145_DZ",
    "M1014_DZ",
    "M1014_CCO_DZ",
    "M1014_Holo_DZ",
    "Mk48_CCO_DZ",
    "Mk48_DZ",
    "Mk48_Holo_DZ",
    "Mk48_DES_CCO_DZ",
    "PKM_DZ",
    "Pecheneg_DZ",
    "UK59_DZ",
    "RPK74_Kobra_DZ",
    "RPK74_DZ",
    "RPK74_PSO1_DZ",
    "SVD_PSO1_DZ",
    "SVD_PSO1_Gh_DZ",
    "SVD_DZ",
    "SVD_Gh_DZ",
    "SVD_PSO1_Gh_DES_DZ",
    "SVD_NSPU_DZ",
    "SVD_Gold_DZ",
    "SVU_PSO1_DZ",
    "VSS_vintorez_DZE",
    "VAL_DZ",
    "VAL_Kobra_DZ",
    "VAL_PSO1_DZ",
    "KSVK_DZE",
    "Mosin_DZ",
    "Mosin_BR_DZ",
    "Mosin_FL_DZ",
    "Mosin_MFL_DZ",
    "Mosin_Belt_DZ",
    "Mosin_Belt_FL_DZ",
    "Mosin_Belt_MFL_DZ",
    "Mosin_PU_DZ",
    "Mosin_PU_FL_DZ",
    "Mosin_PU_MFL_DZ",
    "Mosin_PU_Belt_DZ",
    "Mosin_PU_Belt_FL_DZ",
    "Mosin_PU_Belt_MFL_DZ",
    "MP5_DZ",
    "MP5_SD_DZ",
    "Kriss_DZ",
    "Kriss_CCO_DZ",
    "Kriss_Holo_DZ",
    "Kriss_SD_DZ",
    "Kriss_CCO_SD_DZ",
    "Kriss_Holo_SD_DZ",
    "Scorpion_Evo3_DZ",
    "Scorpion_Evo3_CCO_DZ",
    "Scorpion_Evo3_CCO_SD_DZ",
    "MP7_DZ",
    "MP7_FL_DZ",
    "MP7_MFL_DZ",
    "MP7_Holo_DZ",
    "MP7_Holo_FL_DZ",
    "MP7_Holo_MFL_DZ",
    "MP7_CCO_DZ",
    "MP7_CCO_FL_DZ",
    "MP7_CCO_MFL_DZ",
    "MP7_ACOG_DZ",
    "MP7_ACOG_FL_DZ",
    "MP7_ACOG_MFL_DZ",
    "MP7_SD_DZ",
    "MP7_SD_FL_DZ",
    "MP7_SD_MFL_DZ",
    "MP7_Holo_SD_DZ",
    "MP7_Holo_SD_FL_DZ",
    "MP7_Holo_SD_MFL_DZ",
    "MP7_CCO_SD_DZ",
    "MP7_CCO_SD_FL_DZ",
    "MP7_CCO_SD_MFL_DZ",
    "MP7_ACOG_SD_DZ",
    "MP7_ACOG_SD_FL_DZ",
    "MP7_ACOG_SD_MFL_DZ",
    "TMP_DZ",
    "TMP_CCO_DZ",
    "TMP_Holo_DZ",
    "TMP_SD_DZ",
    "TMP_CCO_SD_DZ",
    "TMP_Holo_SD_DZ",
    "UMP_DZ",
    "UMP_CCO_DZ",
    "UMP_Holo_DZ",
    "UMP_SD_DZ",
    "UMP_CCO_SD_DZ",
    "UMP_Holo_SD_DZ",
    "P90_DZ",
    "P90_CCO_DZ",
    "P90_Holo_DZ",
    "P90_SD_DZ",
    "P90_CCO_SD_DZ",
    "P90_Holo_SD_DZ",
    "Sten_MK_DZ",
    "MAT49_DZ",
    "M31_DZ",
    "M16A2_DZ",
    "M16A2_GL_DZ",
    "M16A2_Rusty_DZ",
    "M16A4_DZ",
    "M16A4_FL_DZ",
    "M16A4_MFL_DZ",
    "M16A4_GL_DZ",
    "M16A4_GL_FL_DZ",
    "M16A4_GL_MFL_DZ",
    "M16A4_CCO_DZ",
    "M16A4_CCO_FL_DZ",
    "M16A4_CCO_MFL_DZ",
    "M16A4_GL_CCO_DZ",
    "M16A4_GL_CCO_FL_DZ",
    "M16A4_GL_CCO_MFL_DZ",
    "M16A4_Holo_DZ",
    "M16A4_Holo_FL_DZ",
    "M16A4_Holo_MFL_DZ",
    "M16A4_GL_Holo_DZ",
    "M16A4_GL_Holo_FL_DZ",
    "M16A4_GL_Holo_MFL_DZ",
    "M16A4_ACOG_DZ",
    "M16A4_ACOG_FL_DZ",
    "M16A4_ACOG_MFL_DZ",
    "M16A4_GL_ACOG_DZ",
    "M16A4_GL_ACOG_FL_DZ",
    "M16A4_GL_ACOG_MFL_DZ",
    "SA58_DZ",
    "SA58_RIS_DZ",
    "SA58_RIS_FL_DZ",
    "SA58_RIS_MFL_DZ",
    "SA58_CCO_DZ",
    "SA58_CCO_FL_DZ",
    "SA58_CCO_MFL_DZ",
    "SA58_Holo_DZ",
    "SA58_Holo_FL_DZ",
    "SA58_Holo_MFL_DZ",
    "SA58_ACOG_DZ",
    "SA58_ACOG_FL_DZ",
    "SA58_ACOG_MFL_DZ",
    "Sa58V_DZ",
    "Sa58V_Camo_CCO_DZ",
    "Sa58V_Camo_ACOG_DZ",
    "L85A2_DZ",
    "L85A2_FL_DZ",
    "L85A2_MFL_DZ",
    "L85A2_SD_DZ",
    "L85A2_SD_FL_DZ",
    "L85A2_SD_MFL_DZ",
    "L85A2_CCO_DZ",
    "L85A2_CCO_FL_DZ",
    "L85A2_CCO_MFL_DZ",
    "L85A2_CCO_SD_DZ",
    "L85A2_CCO_SD_FL_DZ",
    "L85A2_CCO_SD_MFL_DZ",
    "L85A2_Holo_DZ",
    "L85A2_Holo_FL_DZ",
    "L85A2_Holo_MFL_DZ",
    "L85A2_Holo_SD_DZ",
    "L85A2_Holo_SD_FL_DZ",
    "L85A2_Holo_SD_MFL_DZ",
    "L85A2_ACOG_DZ",
    "L85A2_ACOG_FL_DZ",
    "L85A2_ACOG_MFL_DZ",
    "L85A2_ACOG_SD_DZ",
    "L85A2_ACOG_SD_FL_DZ",
    "L85A2_ACOG_SD_MFL_DZ",
    "BAF_L85A2_RIS_TWS_DZ",
    "L86A2_LSW_DZ",
    "Bizon_DZ",
    "Bizon_Kobra_DZ",
    "Bizon_SD_DZ",
    "Bizon_Kobra_SD_DZ",
    "CZ550_DZ",
    "LeeEnfield_DZ",
    "MR43_DZ",
    "Winchester1866_DZ",
    "Remington870_DZ",
    "Remington870_FL_DZ",
    "Remington870_MFL_DZ",
    "Saiga12K_DZ",
    "USAS12_DZ",
    "AA12_DZ",
    "Crossbow_DZ",
    "Crossbow_FL_DZ",
    "Crossbow_MFL_DZ",
    "Crossbow_CCO_DZ",
    "Crossbow_CCO_FL_DZ",
    "Crossbow_CCO_MFL_DZ",
    "Crossbow_Scope_DZ",
    "Crossbow_Scope_FL_DZ",
    "Crossbow_Scope_MFL_DZ",
    "L115A3_DZ",
    "L115A3_2_DZ",
    "MSR_DZ",
    "MSR_SD_DZ",
    "MSR_NV_DZ",
    "MSR_NV_SD_DZ",
    "MSR_TWS_DZ",
    "MSR_TWS_SD_DZ",
    "XM2010_DZ",
    "XM2010_SD_DZ",
    "XM2010_NV_DZ",
    "XM2010_NV_SD_DZ",
    "XM2010_TWS_DZ",
    "XM2010_TWS_SD_DZ",
    "Anzio_20_DZ",
    "BAF_AS50_scoped_DZ",
    "m107_DZ",
    "m107_SKN",
    "M4SPR_DZE",
    "M200_CheyTac_DZ",
    "M200_CheyTac_SD_DZ",
    "WA2000_DZ",
    "Barrett_MRAD_Iron_DZ",
    "Barrett_MRAD_CCO_DZ",
    "Barrett_MRAD_Sniper_DZ",
    "M9_DZ",
    "M9_SD_DZ",
    "M9_Camo_DZ",
    "M9_Camo_SD_DZ",
    "M93R_DZ",
    "P99_Black_DZ",
    "P99_Black_SD_DZ",
    "P99_Green_DZ",
    "P99_Green_SD_DZ",
    "P99_Silver_DZ",
    "P99_Silver_SD_DZ",
    "BrowningHP_DZ",
    "P226_DZ",
    "P226_Silver_DZ",
    "P38_DZ",
    "PPK_DZ",
    "MK22_DZ",
    "MK22_2_DZ",
    "MK22_SD_DZ",
    "MK22_2_SD_DZ",
    "G17_DZ",
    "G17_FL_DZ",
    "G17_MFL_DZ",
    "G17_SD_DZ",
    "G17_SD_FL_DZ",
    "G17_SD_MFL_DZ",
    "G18_DZ",
    "M1911_DZ",
    "M1911_2_DZ",
    "Kimber_M1911_DZ",
    "Kimber_M1911_SD_DZ",
    "USP_DZ",
    "USP_SD_DZ",
    "Makarov_DZ",
    "Makarov_SD_DZ",
    "Tokarew_TT33_DZ",
    "Ruger_MK2_DZ",
    "APS_DZ",
    "APS_SD_DZ",
    "PDW_DZ",
    "PDW_SD_DZ",
    "TEC9_DZ",
    "Mac10_DZ",
    "Revolver_DZ",
    "Revolver_Gold_DZ",
    "Colt_Anaconda_DZ",
    "Colt_Anaconda_Gold_DZ",
    "Colt_Bull_DZ",
    "Colt_Python_DZ",
    "Colt_Revolver_DZ",
    "CZ75P_DZ",
    "CZ75D_DZ",
    "CZ75SP_DZ",
    "CZ75SP_SD_DZ",
    "DesertEagle_DZ",
    "DesertEagle_Gold_DZ",
    "DesertEagle_Silver_DZ",
    "DesertEagle_Modern_DZ",
    "Sa61_DZ",
    "MeleeHatchet",
    "MeleeCrowbar",
    "MeleeMachete",
    "MeleeBaseBallBat",
    "MeleeBaseBallBatBarbed",
    "MeleeBaseBallBatNails",
    "MeleeFishingPole",
    "MeleeSledge",
    "BinocularBroken",
    "ItemNVGBroken_DZE",
    "NVGoggles_DZE",
    "ItemNVGFullBroken_DZE",
    "Binocular_VectorBroken",
    "ChainSaw",
    "ChainSawB",
    "ChainSawG",
    "ChainSawP",
    "ChainSawR",
    "ChainSawBroken",
    "ChainSawBBroken",
    "ChainSawGBroken",
    "ChainSawPBroken",
    "ChainSawRBroken",
    "ItemMap_Debug",
    "ItemGPSBroken_DZE",
    "ItemKnife",
    "ItemKnife5",
    "ItemKnife4",
    "ItemKnife3",
    "ItemKnife2",
    "ItemKnife1",
    "ItemKnifeBlunt",
    "ItemMatchboxEmpty",
    "ItemMatchbox",
    "Item5Matchbox",
    "Item4Matchbox",
    "Item3Matchbox",
    "Item2Matchbox",
    "Item1Matchbox",
    "ItemToolbox",
    "ItemToolboxBroken",
    "ItemEtool",
    "ItemEtoolBroken",
    "ItemFishingPole",
    "ItemFishingPoleBroken",
    "ItemShovel",
    "ItemShovelBroken",
    "ItemPickaxe",
    "ItemPickaxeBroken",
    "ItemSledge",
    "ItemSledgeBroken",
    "ItemSledgeHammer",
    "ItemSledgeHammerBroken",
    "ItemCrowbar",
    "ItemCrowbarBent",
    "ItemHatchet",
    "ItemHatchetBroken",
    "ItemMachete",
    "ItemMacheteBroken",
    "ItemFlashlight",
    "ItemFlashlightBroken",
    "MeleeFlashlight",
    "ItemFlashlightRed",
    "ItemFlashlightRedBroken",
    "MeleeFlashlightRed",
    "ItemRadioBroken_DZE",
    "ItemKeyKit",
    "ItemKeyKitBroken",
    "ItemAPSI_DZE",
    "ItemAPSIBroken_DZE",
    "ItemPilotmask_DZE",
    "ItemPilotmaskBroken_DZE",
    "ItemGasmask1_DZE",
    "ItemGasmask1Broken_DZE",
    "ItemGasmask2_DZE",
    "ItemGasmask2Broken_DZE",
    "ItemSolder_DZE",
    "ItemSolderBroken_DZE",
    "Cuffs_DZE",
    "CuffsBroken_DZE",
    "Hammer_DZE",
    "HammerBroken_DZE",
    "Handsaw_DZE",
    "HandsawBroken_DZE",
    "Smartphone_DZE",
    "SmartphoneBroken_DZE",
    "Scissors_DZE",
    "ScissorsBroken_DZE",
    "Screwdriver_DZE",
    "ScrewdriverBroken_DZE",
    "Wrench_DZE",
    "WrenchBroken_DZE",
    "Notebook_bio_DZE",
    "Notebook_che_DZE",
    "Notebook_phy_DZE",
    "Notebook_secret_DZE",
    "Notebook_herbs_DZE",
    "Document_Random_DZE",
    "Document_Military_DZE",
    "Document_Topsecret_DZE",
    "Manual_electronics_DZE",
    "Manual_camera_DZE",
    "Manual_repair_DZE",
    "Map_Military_DZE",
    "Map_Survivor_DZE",
  ],
  selectedClasses: {
    weapons: [],
    magazines: [],
    backpacks: [],
  },
  playerList: [],
  mapVisibility: {
    plotpoles: false,
    safes: false,
    zeroedSafes: false,
    vehicles: false,
    veins: false,
    backpacks: false,
    deadBodies: false
  }
};

export const gameSlice = createSlice({
  name: "game",
  initialState,
  reducers: {
    togglePlotpolesVisiblity: (state, action) => {
      state.mapVisibility = {...state.mapVisibility, plotpoles: action.payload};
      return state;
    },
    toggleSafesVisiblity: (state, action) => {
      state.mapVisibility = {...state.mapVisibility, safes: action.payload};
      return state;
    },
    toggleZeroedSafesVisiblity: (state, action) => {
      state.mapVisibility = {...state.mapVisibility, zeroedSafes: action.payload};
      return state;
    },
    toggleVehiclesVisiblity: (state, action) => {
      state.mapVisibility = {...state.mapVisibility, vehicles: action.payload};
      return state;
    },
    toggleVeinsVisiblity: (state, action) => {
      state.mapVisibility = {...state.mapVisibility, veins: action.payload};
      return state;
    },
    toggleBackpacksVisiblity: (state, action) => {
      state.mapVisibility = {...state.mapVisibility, backpacks: action.payload};
      return state;
    },
    toggleDeadBodiesVisiblity: (state, action) => {
      state.mapVisibility = {...state.mapVisibility, deadBodies: action.payload};
      return state;
    },
    setBackpackClasses: (state, action) => {
      state.backpackClasses = action.payload;
      return state;
    },
    setMagazineClasses: (state, action) => {
      state.magazineClasses = action.payload;
      return state;
    },
    setWeaponClasses: (state, action) => {
      state.weaponClasses = action.payload;
      return state;
    },
    setPlayerList: (state, action) => {
      state.playerList = action.payload;
      return state;
    },
    reset: (state) => {
      state = initialState;
      return state;
    },
    addWeaponSelectionItemStack: (state, action) => {
      const newStack: ItemStack = action.payload;
      if (
        state.selectedClasses.weapons.findIndex(
          (s) => s.classname === newStack.classname
        ) === -1
      ) {
        if (newStack.amount > 0) {
          state.selectedClasses.weapons.push(newStack);
        }
      } else {
        const entry = state.selectedClasses.weapons.find(
          (s) => s.classname === newStack.classname
        )!;
        entry.amount += newStack.amount;
        if (entry.amount <= 0) {
          state.selectedClasses.weapons = state.selectedClasses.weapons.filter(
            (w) => w.classname !== newStack.classname
          );
        }
      }
      return state;
    },
    addMagazineSelectionItemStack: (state, action) => {
      const newStack: ItemStack = action.payload;
      if (
        state.selectedClasses.magazines.findIndex(
          (s) => s.classname === newStack.classname
        ) === -1
      ) {
        if (newStack.amount > 0) {
          state.selectedClasses.magazines.push(newStack);
        }
      } else {
        const entry = state.selectedClasses.magazines.find(
          (s) => s.classname === newStack.classname
        )!;
        entry.amount += newStack.amount;
        if (entry.amount <= 0) {
          state.selectedClasses.magazines =
            state.selectedClasses.magazines.filter(
              (m) => m.classname !== newStack.classname
            );
        }
      }
      return state;
    },
    addBackpackSelectionItemStack: (state, action) => {
      const newStack: ItemStack = action.payload;
      if (
        state.selectedClasses.backpacks.findIndex(
          (s) => s.classname === newStack.classname
        ) === -1
      ) {
        if (newStack.amount > 0) {
          state.selectedClasses.backpacks.push(newStack);
        }
      } else {
        const entry = state.selectedClasses.backpacks.find(
          (s) => s.classname === newStack.classname
        )!;
        entry.amount += newStack.amount;
        if (entry.amount <= 0) {
          state.selectedClasses.backpacks =
            state.selectedClasses.backpacks.filter(
              (b) => b.classname !== newStack.classname
            );
        }
      }
      return state;
    },
    clearSelection: (state) => {
      state.selectedClasses = initialState.selectedClasses;
      return state;
    },
  },
});

export const gameActions = gameSlice.actions;
export const gameSliceReducers = gameSlice.reducer;
